import * as THREE from 'three';
const phaseATimeline = gsap.timeline({paused: true});

// Variables para el loader
let resourcesLoaded = false;
let videoLoaded = false;
let texturesLoaded = 0;
const totalTextures = 1; // background1.jpg, the10black.png, essence-bg.png
const LOADER_MAX_TIME = 10000;
let loaderTimeout = setTimeout(() => {
    console.warn('⚠️ Timeout del loader alcanzado');
    resourcesLoaded = true;
    document.querySelector('.progress-bar').style.width = '100%';
    setTimeout(() => {
        document.getElementById('loader').style.opacity = '0';
        setTimeout(() => {
            document.getElementById('loader').style.display = 'none';
            phaseATimeline.play();
        }, 500);
    }, 300);
}, LOADER_MAX_TIME);
const updateProgress = () => {
    const progress = ((videoLoaded ? 1 : 0) + texturesLoaded) / (1 + totalTextures) * 100;
    document.querySelector('.progress-bar').style.width = `${progress}%`;

    // Si todo está cargado, ocultamos el loader
    if (videoLoaded && texturesLoaded >= totalTextures) {
        resourcesLoaded = true;
        setTimeout(() => {
            document.getElementById('loader').style.opacity = '0';
            setTimeout(() => {
                document.getElementById('loader').style.display = 'none';
                phaseATimeline.play();
            }, 500);
        }, 300);
    }
};

// Crear un loader de texturas centralizado
const textureLoader = new THREE.TextureLoader();
textureLoader.onLoad = function() {
    texturesLoaded++;
    updateProgress();
};

// Modificar donde se cargan las texturas para usar el loader centralizado
// Por ejemplo, reemplazar:
// const backgroundTexture = new THREE.TextureLoader().load('background1.jpg');
// Por:
// const backgroundTexture = textureLoader.load('background1.jpg');

// Comprobar si la imagen de fondo ya está cargada
const bgImage = new Image();
bgImage.src = '/resources/essence-bg.webp';
bgImage.onload = function() {
    texturesLoaded++;
    updateProgress();
};

// Registramos el plugin ScrollTrigger con GSAP
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText);

let phaseBTimeline = null;
let starsCanvas = null;
let starsScene = null;
let starsCamera = null;
let starsRenderer = null;
let starsActive = false;

const canvas = document.querySelector('.webgl');
const scene = new THREE.Scene();

// Función para obtener la altura fija para iOS
function getFixedHeight() {
    if (isIOSDevice()) {
        return Math.max(window.innerHeight, window.screen.height * 0.8);
    }
    return window.innerHeight;
}

const sizes = {
    width: window.innerWidth,
    height: getFixedHeight() - 50 // Usar altura fija en iOS
};

const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100);
camera.position.z = 2;
scene.add(camera);

const renderer = new THREE.WebGLRenderer({ canvas, alpha: true, antialias: true });
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

const video = document.createElement('video');
video.src = mainVideoSrc;
video.muted = true;
video.loop = true;
video.autoplay = true;
video.playsInline = true;
video.play().catch(e => console.warn("Autoplay bloqueado:", e));

let soundEnabled = false;

// Referencia al botón de sonido
const soundToggle = document.getElementById('sound-toggle');

// Función para actualizar la UI en base al estado del sonido
function updateSoundUI() {
    if (soundEnabled) {
        soundToggle.classList.remove('muted');
        soundToggle.querySelector('.sound-label').textContent = "SOUND ON";
    } else {
        soundToggle.classList.add('muted');
        soundToggle.querySelector('.sound-label').textContent = "SOUND OFF";
    }
}

// Manejar el clic en el botón de sonido
soundToggle.addEventListener('click', () => {
    if (video) {
        soundEnabled = !soundEnabled;
        video.muted = !soundEnabled;

        // Si se activa el sonido por primera vez, intentamos reproducir el video
        // Esto es necesario debido a las políticas de autoplay de los navegadores
        if (soundEnabled) {
            video.play().catch(err => {
                console.warn("No se pudo reproducir el video:", err);
                // Si falla la reproducción, volvemos al estado anterior
                soundEnabled = false;
                video.muted = true;
            });
        }

        updateSoundUI();
    }
});

// Actualizar la UI inicial
updateSoundUI();

function createStarsCanvas() {
    if (starsCanvas) return; // Evitar crear múltiples veces


    // Crear el elemento canvas para stars
    starsCanvas = document.createElement('canvas');
    starsCanvas.className = 'webgl-stars';
    starsCanvas.style.position = 'fixed';
    starsCanvas.style.top = '0';
    starsCanvas.style.left = '0';
    starsCanvas.style.width = '100%';
    starsCanvas.style.height = '100%';
    starsCanvas.style.zIndex = '3';
    starsCanvas.style.pointerEvents = 'none';
    starsCanvas.style.opacity = '1';
    starsCanvas.style.visibility = 'hidden';

    if (isIOSDevice()) {
        starsCanvas.style.webkitTransform = 'translateZ(0)';
        starsCanvas.style.transform = 'translateZ(0)';
        starsCanvas.style.webkitBackfaceVisibility = 'hidden';
        starsCanvas.style.backfaceVisibility = 'hidden';
        starsCanvas.style.webkitPerspective = '1000px';
        starsCanvas.style.perspective = '1000px';
    }

    // Insertar el canvas después del canvas principal
    const mainCanvas = document.querySelector('.webgl');
    mainCanvas.parentNode.insertBefore(starsCanvas, mainCanvas.nextSibling);

    // Configurar Three.js para el nuevo canvas
    starsScene = new THREE.Scene();
    starsCamera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100);
    starsCamera.position.z = 2;
    starsScene.add(starsCamera);

    const rendererOptions = {
        canvas: starsCanvas,
        alpha: true,
        antialias: !isIOSDevice(), // Desactivar antialiasing en iOS para mejor rendimiento
        powerPreference: "high-performance",
        preserveDrawingBuffer: isIOSDevice(), // CRÍTICO para iOS
        premultipliedAlpha: false
    };

    starsRenderer = new THREE.WebGLRenderer(rendererOptions);
    starsRenderer.setSize(sizes.width, sizes.height);
    starsRenderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

    if (isIOSDevice()) {
        starsRenderer.autoClear = true;
        starsRenderer.setClearColor(0x000000, 0);
        starsRenderer.sortObjects = false;
        starsRenderer.domElement.style.webkitTransform = 'translateZ(0)';
    }

    if (isMobileDevice()) {
        const starsContainer = document.querySelector('.star-cards-container');
        starsContainer.style.height = mainCanvas.style.height;
    }

    // Inicializar contenido
    initStarsContent();

    // Hacer una primera renderización preparatoria
    starsRenderer.render(starsScene, starsCamera);

}

function forceStarsRender() {
    if (starsRenderer && starsScene && starsCamera && starsActive) {
        try {
            starsRenderer.render(starsScene, starsCamera);
        } catch (e) {
            console.warn('Error en forceStarsRender:', e);
        }
    }
}

let planes = [];
let borderMeshes = []
let fullPlane = null;
let blackPlane = null;
let essenceTextPlanes = {
    first: null,
    second: null,
    third: null,
    fourth: null
};
let stadiumPlaneBack = null;
let stadiumBlackPlane = null;
let stadiumMaterialLight = null;
let stadiumTextureFront = null;
let stadiumTextureDegradation = null;
let stadiumTextureStadium = null;
let stadiumPlaneLight = null;
let stadiumPlaneFront = null;
let stadiumPlaneDegradation = null;
let stadiumPlaneStadium = null;
let stadiumFrontGroup = null;
let stadiumFrontPositionGroup = null;
let stadiumStadiumGroup = null;
let stadiumBackGroup = null;
let stadiumMaterialArena = null;
let stadiumMaterialEssence = null;
let stadiumPlaneArena = null;
let stadiumPlaneArenaWrapper = null;
let stadiumPlaneEssence = null;
let stadiumMaterialDegradation = null;
let logoMesh = null;
let initialPositions = [];
let visibleWidth = 0;
let visibleHeight = 0;
let starsStadiumAspect = 1030 / 1920;
let starsStadiumWidth = 0;
let starsStadiumHeight = 0;
let holeRadius = 0.0;
let holeUniform = { value: holeRadius };
let blackShaderMaterial = null;
let essenceHoverEnabled = false;
let scrollBGPlane = null;
let textPlaneBelieve = null;
let essenceScrollHeight = 0;
let essenceScrollWidth = 0;
const popupTitle = document.querySelector('.popup-title');
let popupTitleAnimation = null;
let popupTitleHoverAnimation = null;
let starsStadiumPlane = null;
let starsScreensPlane = null;
let starsStadiumGroup = null;
let starsCards = [];
let starsCurtainUniforms = null;
let starsCurtainMaterial = null;
let starsBackgroundPlane = null;
let starsTitlePlane = null;
let starsMainGroup = null;
let starsGroupRenderTarget = null;
let starsCurtainPlane = null;
let starsCurtainScene = null;
let starsCurtainCamera = null;
let starsPreloaded = false;
let starsPreloadTriggered = false;
const stadiumHoverScale = 1.05;
let iosScrollTimeout = null;
let iosScrolling = false;
let iosRenderInterval = null;
const blackMaterial = new THREE.MeshBasicMaterial({ color: 0x000000 });
const popup = document.querySelector('.popup');

// Function to create a rounded rectangle shape
function createRoundedRectangle(width, height, radius) {
    const shape = new THREE.Shape();

    // Start at the top left corner
    shape.moveTo(-width/2 + radius, height/2);

    // Top edge
    shape.lineTo(width/2 - radius, height/2);

    // Top right corner
    shape.quadraticCurveTo(width/2, height/2, width/2, height/2 - radius);

    // Right edge
    shape.lineTo(width/2, -height/2 + radius);

    // Bottom right corner
    shape.quadraticCurveTo(width/2, -height/2, width/2 - radius, -height/2);

    // Bottom edge
    shape.lineTo(-width/2 + radius, -height/2);

    // Bottom left corner
    shape.quadraticCurveTo(-width/2, -height/2, -width/2, -height/2 + radius);

    // Left edge
    shape.lineTo(-width/2, height/2 - radius);

    // Top left corner
    shape.quadraticCurveTo(-width/2, height/2, -width/2 + radius, height/2);

    return shape;
}

// Initialize planes after video loads
video.addEventListener("loadeddata", () => {
    videoLoaded = true;
    updateProgress();
    const videoTexture = new THREE.VideoTexture(video);
    videoTexture.minFilter = THREE.LinearFilter;
    videoTexture.magFilter = THREE.LinearFilter;
    videoTexture.format = THREE.RGBAFormat;
    videoTexture.type = THREE.UnsignedByteType;
    videoTexture.generateMipmaps = false;
    videoTexture.colorSpace = THREE.SRGBColorSpace;

    const maskTexture = textureLoader.load('/resources/the10black.png');
    maskTexture.minFilter = THREE.LinearFilter;
    maskTexture.magFilter = THREE.LinearFilter;
    maskTexture.generateMipmaps = false;
    maskTexture.colorSpace = THREE.SRGBColorSpace;

    visibleHeight = 2 * Math.tan((camera.fov * Math.PI) / 360) * camera.position.z;
    visibleWidth = visibleHeight * camera.aspect;

    const isMobile = isMobileDevice();

    let planeWidth, planeHeight;
    if (isMobile) {
        // MÓVIL: Calcular dimensiones respetando el aspect ratio del video
        const videoAspect = 1920/1080;
        const screenAspect = visibleWidth / visibleHeight;

        if (videoAspect < screenAspect) {
            // Video más ancho que pantalla: ajustar por altura y dividir verticalmente
            planeWidth = visibleWidth;
            const fullVideoHeight = visibleWidth / videoAspect; // Altura real del video sin deformar
            planeHeight = fullVideoHeight / 3; // Dividir en 3 partes verticales
        } else {
            // Video más alto que pantalla: ajustar por ancho y dividir verticalmente
            const fullVideoWidth = visibleHeight * videoAspect; // Ancho real del video sin deformar
            planeWidth = fullVideoWidth;
            planeHeight = visibleHeight / 3; // Dividir en 3 partes verticales
        }

        starsStadiumHeight = visibleHeight;
        starsStadiumWidth = starsStadiumHeight / starsStadiumAspect;
    } else {
        // Escritorio: mantener los 3 paneles
        planeWidth = visibleWidth / 3;
        planeHeight = visibleHeight;

        starsStadiumWidth = visibleWidth;
        starsStadiumHeight = starsStadiumWidth * starsStadiumAspect;
    }



    if (isMobile) {
        // Posiciones verticales para móvil (Y en lugar de X)
        initialPositions = [
            visibleHeight / 3,   // Panel superior
            0,                   // Panel central
            -visibleHeight / 3   // Panel inferior
        ];
    } else {
        // Posiciones horizontales para escritorio
        initialPositions = [
            -visibleWidth / 3,
            0,
            visibleWidth / 3
        ];
    }

    // Create a single basic material for all planes
    const baseMaterial = new THREE.MeshBasicMaterial({
        map: videoTexture,
        transparent: true
    });

    const backgroundTexture = textureLoader.load('/resources/background1.webp');

    backgroundTexture.minFilter = THREE.LinearFilter;
    backgroundTexture.magFilter = THREE.LinearFilter;
    backgroundTexture.generateMipmaps = false;
    backgroundTexture.colorSpace = THREE.SRGBColorSpace;

    blackShaderMaterial = new THREE.ShaderMaterial({
        uniforms: {
            background: { value: backgroundTexture }
        },
        vertexShader: `
    varying vec2 vUv;
    void main() {
      vUv = uv;
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `,
        fragmentShader: `
    uniform sampler2D background;
    varying vec2 vUv;

    void main() {
      gl_FragColor = texture2D(background, vUv);
    }
  `,
        transparent: false
    });

    // BACKGROUND PLANE
    if (isMobile) {
        // En móvil, hacer que el video de fondo cubra toda la pantalla sin deformarse
        const videoAspect = 1920/1080;
        const screenAspect = visibleWidth / visibleHeight;

        let bgWidth = visibleWidth;
        let bgHeight = visibleHeight;

        if (videoAspect > screenAspect) {
            // Video más ancho que pantalla: ajustar por altura
            bgHeight = visibleHeight;
            bgWidth = bgHeight * videoAspect;
        } else {
            // Video más alto que pantalla: ajustar por ancho
            bgWidth = visibleWidth;
            bgHeight = bgWidth / videoAspect;
        }

        fullPlane = new THREE.Mesh(
            new THREE.PlaneGeometry(bgWidth, bgHeight),
            baseMaterial.clone()
        );
    } else {
        // Escritorio: mantener como estaba
        fullPlane = new THREE.Mesh(
            new THREE.PlaneGeometry(visibleWidth, visibleHeight),
            baseMaterial.clone()
        );
    }

    fullPlane.position.z = -0.0001;
    fullPlane.material.transparent = true;
    fullPlane.material.opacity = 1;
    scene.add(fullPlane);

    // BLACK PLANE
        blackPlane = new THREE.Mesh(
            new THREE.PlaneGeometry(visibleWidth * 1.1, visibleHeight * 1.1),
            blackShaderMaterial
        );
        blackPlane.position.z = -0.0002;
        blackPlane.material.transparent = false;
        blackPlane.material.opacity = 1;
        scene.add(blackPlane);

    // Create front panels with reduced size but correct UVs to blend with background
    // CREAR PANELES FRONTALES - Modificado para móvil
    if (isMobile) {
        // MÓVIL: Crear 3 paneles verticales
        for (let i = 0; i < 3; i++) {
            const shrink = 0.985;

            // Calcular dimensiones del panel visible
            const visiblePanelWidth = visibleWidth * shrink; // Ancho que queremos mostrar
            const visiblePanelHeight = planeHeight * shrink;

            // Mantener el ancho completo del video para el cálculo de UVs
            const fullVideoWidth = planeWidth; // Este es el ancho real del video sin deformar

            const cornerRadius = Math.min(visiblePanelWidth, visiblePanelHeight) * 0.05;

            // Crear geometría con el tamaño visible deseado
            const roundedRectShape = createRoundedRectangle(visiblePanelWidth, visiblePanelHeight, cornerRadius);
            const geometry = new THREE.ShapeGeometry(roundedRectShape, 16);

            geometry.computeBoundingBox();
            const bbox = geometry.boundingBox;
            const uvAttr = geometry.attributes.uv;
            const posAttr = geometry.attributes.position;

            // Calcular el offset horizontal para centrar el video
            const videoOffset = (fullVideoWidth - visiblePanelWidth) / fullVideoWidth / 2;

            for (let j = 0; j < uvAttr.count; j++) {
                const x = posAttr.getX(j);
                const y = posAttr.getY(j);

                // Normalizar las coordenadas del vértice respecto al bounding box
                let u = (x - bbox.min.x) / (bbox.max.x - bbox.min.x);
                let v = (y - bbox.min.y) / (bbox.max.y - bbox.min.y);

                // Mapear UV para mantener el aspect ratio del video
                // Centrar horizontalmente el video en el panel más estrecho
                u = u * (visiblePanelWidth / fullVideoWidth) + videoOffset;

                // Mapear verticalmente según el segmento (igual que antes)
                const verticalSegment = 2 - i; // Invertir el orden
                v = (v * shrink) / 3 + verticalSegment / 3 + (1 - shrink) / 6;

                uvAttr.setXY(j, u, v);
            }
            uvAttr.needsUpdate = true;

            const material = baseMaterial.clone();
            const mesh = new THREE.Mesh(geometry, material);

            // Posicionar verticalmente
            mesh.position.y = visibleHeight / 3 - i * planeHeight;
            mesh.position.x = 0;
            mesh.position.z = 0.001;
            mesh.visible = true;
            scene.add(mesh);

            // Crear bordes
            const borderMaterial = new THREE.MeshBasicMaterial({
                color: 0xffffff,
                transparent: true,
                opacity: 0,
                depthTest: true,
                depthWrite: false
            });
            const borderMesh = new THREE.Mesh(geometry.clone(), borderMaterial);
            borderMesh.scale.multiplyScalar(1.005);
            borderMesh.position.copy(mesh.position);
            borderMesh.position.z -= 0.001;
            scene.add(borderMesh);
            borderMeshes.push(borderMesh);

            planes.push(mesh);
        }
    } else {
        // ESCRITORIO: Mantener los 3 paneles como estaba
        initialPositions = [
            -visibleWidth / 3,
            0,
            visibleWidth / 3
        ];

        for (let i = 0; i < 3; i++) {
            const shrink = 0.985;
            const width = planeWidth * shrink;
            const height = planeHeight * shrink;
            const cornerRadius = width * 0.05;

            const roundedRectShape = createRoundedRectangle(width, height, cornerRadius);
            const geometry = new THREE.ShapeGeometry(roundedRectShape, 16);

            geometry.computeBoundingBox();
            const bbox = geometry.boundingBox;
            const uvAttr = geometry.attributes.uv;
            const posAttr = geometry.attributes.position;

            const offsetFactor = (1 - shrink) / 2;
            const offsetU = offsetFactor / 3;
            const offsetV = offsetFactor;
            const segmentWidth = 1 / 3;

            for (let j = 0; j < uvAttr.count; j++) {
                const x = posAttr.getX(j);
                const y = posAttr.getY(j);

                let u = (x - bbox.min.x) / (bbox.max.x - bbox.min.x);
                let v = (y - bbox.min.y) / (bbox.max.y - bbox.min.y);

                u = (u * shrink) / 3 + i / 3 + offsetU;
                v = v * shrink + offsetV;

                uvAttr.setXY(j, u, v);
            }
            uvAttr.needsUpdate = true;

            const material = baseMaterial.clone();
            const mesh = new THREE.Mesh(geometry, material);
            mesh.position.x = -visibleWidth / 3 + i * planeWidth;
            mesh.position.z = 0.001;
            mesh.visible = true;
            scene.add(mesh);

            const borderMaterial = new THREE.MeshBasicMaterial({
                color: 0xffffff,
                transparent: true,
                opacity: 0,
                depthTest: true,
                depthWrite: false
            });
            const borderMesh = new THREE.Mesh(geometry.clone(), borderMaterial);
            borderMesh.scale.multiplyScalar(1.005);
            borderMesh.position.copy(mesh.position);
            borderMesh.position.z -= 0.001;
            scene.add(borderMesh);
            borderMeshes.push(borderMesh);

            planes.push(mesh);
        }
    }

    const logoAspect = 2647 / 875; // ≈ 3.025
    const logoWidth = isMobile ? visibleWidth / 1.5 : visibleWidth / 4;
    const logoHeight = logoWidth / logoAspect;
    const logoTexture = textureLoader.load('/resources/the10white.png');
    const logoMaterial = new THREE.MeshBasicMaterial({
        map: logoTexture,
        transparent: true,
        opacity: 1
    });
    const logoGeometry = new THREE.PlaneGeometry(logoWidth, logoHeight);
    logoMesh = new THREE.Mesh(logoGeometry, logoMaterial);

// Posición inicial: fuera por arriba
    logoMesh.position.set(0, visibleHeight * 1.2, 0.5);
    scene.add(logoMesh);

    const essenceStadiumAspect = 1076 / 1920;
    const essenceStadiumWidth = visibleWidth;
    const essenceStadiumHeight = visibleWidth * essenceStadiumAspect;
    const essenceScrollAspect = 4950 / 1920;
    essenceScrollWidth = visibleWidth;
    essenceScrollHeight = visibleWidth * essenceScrollAspect;

    let stadiumTextureBackImage = '/resources/the10stadium_back.webp';
    let stadiumPlaneBackWidth = essenceStadiumWidth;
    let stadiumPlaneBackHeight = essenceStadiumHeight;
    if (isMobile) {
        stadiumTextureBackImage = '/resources/the10stadium_mobile_back2.webp';
        stadiumPlaneBackWidth = essenceStadiumWidth * 1.5;
        stadiumPlaneBackHeight = essenceStadiumHeight * 3 / 2;
    }
    const stadiumTextureBack = textureLoader.load(stadiumTextureBackImage);
    stadiumTextureBack.colorSpace = THREE.SRGBColorSpace;
    stadiumTextureBack.minFilter = THREE.LinearFilter;
    stadiumTextureBack.magFilter = THREE.LinearFilter;
    stadiumTextureBack.generateMipmaps = false;

    const stadiumMaterialBack = new THREE.MeshBasicMaterial({ map: stadiumTextureBack,
        transparent: true,
        opacity: 1 });
    stadiumPlaneBack = new THREE.Mesh(
        new THREE.PlaneGeometry(stadiumPlaneBackWidth, stadiumPlaneBackHeight),
        stadiumMaterialBack
    );
    if (isMobile) {
        stadiumPlaneBack.position.y = visibleHeight * 0.28;
    }
    stadiumPlaneBack.position.z = -0.0004; // Detrás del blackPlane (-0.02)
    stadiumPlaneBack.scale.set(6, 6, 1); // Detrás del blackPlane (-0.02)

    // Crear el plano negro de fondo
    const blackPlaneMaterial = new THREE.MeshBasicMaterial({
        color: 0x000000, // Negro
        transparent: false
    });
    stadiumBlackPlane = new THREE.Mesh(
        new THREE.PlaneGeometry(stadiumPlaneBackWidth, stadiumPlaneBackHeight * 0.1),
        blackPlaneMaterial
    );
// Posicionar el plano negro ligeramente detrás del stadiumPlaneBack
    stadiumBlackPlane.position.z = -0.000401; // Un poco más atrás que stadiumPlaneBack
    stadiumBlackPlane.scale.set(6, 6, 1); // Mismo escalado que stadiumPlaneBack
    if (isMobile) {
        stadiumBlackPlane.position.y = visibleHeight * 0.35;
    }

    let stadiumTextureFrontImage = '/resources/the10stadium_front3.webp';
    if (isMobile) {
        stadiumTextureFrontImage = '/resources/the10stadium_mobile_front3.webp';
    }
    stadiumTextureFront = textureLoader.load(stadiumTextureFrontImage, texture => {
        texture.image.crossOrigin = '';
        stadiumTextureFront.imageData = getImageData(texture.image);
    });
    stadiumTextureFront.colorSpace = THREE.SRGBColorSpace;
    stadiumTextureFront.minFilter = THREE.LinearFilter;
    stadiumTextureFront.magFilter = THREE.LinearFilter;
    stadiumTextureFront.generateMipmaps = false;

    const stadiumMaterialFront = new THREE.MeshBasicMaterial({
        map: stadiumTextureFront,
        transparent: true,
    });
    stadiumPlaneFront = new THREE.Mesh(
        new THREE.PlaneGeometry(essenceScrollWidth, essenceScrollHeight),
        stadiumMaterialFront
    );
    stadiumPlaneFront.position.y = visibleWidth/visibleHeight * -3.21;
    stadiumPlaneFront.position.z = -0.0004; // Detrás del blackPlane (-0.02)
    stadiumPlaneFront.scale.set(1, 1, 1);

    let stadiumTextureDegradationImage = '/resources/the10stadium_degradation.webp';
    if (isMobile) {
        stadiumTextureDegradationImage = '/resources/the10stadium_mobile_degradation.webp';
    }
    stadiumTextureDegradation = textureLoader.load(stadiumTextureDegradationImage, texture => {
        texture.image.crossOrigin = '';
        stadiumTextureFront.imageData = getImageData(texture.image);
    });
    stadiumTextureDegradation.colorSpace = THREE.SRGBColorSpace;
    stadiumTextureDegradation.minFilter = THREE.LinearFilter;
    stadiumTextureDegradation.magFilter = THREE.LinearFilter;
    stadiumTextureDegradation.generateMipmaps = false;

    const stadiumMaterialDegradation = new THREE.MeshBasicMaterial({
        map: stadiumTextureDegradation,
        transparent: true,
    });
    stadiumPlaneDegradation = new THREE.Mesh(
        new THREE.PlaneGeometry(essenceScrollWidth, essenceScrollHeight),
        stadiumMaterialDegradation
    );
    stadiumPlaneDegradation.position.y = visibleWidth/visibleHeight * -3.21;
    stadiumPlaneDegradation.position.z = -0.00056; // Detrás del blackPlane (-0.02)
    stadiumPlaneDegradation.scale.set(1, 1, 1);

    let stadiumTextureStadiumImage = '/resources/the10stadium_stadium.webp';
    if (isMobile) {
        stadiumTextureStadiumImage = '/resources/the10stadium_mobile_stadium.webp';
    }
    stadiumTextureStadium = textureLoader.load(stadiumTextureStadiumImage, texture => {
        texture.image.crossOrigin = '';
        stadiumTextureStadium.imageData = getImageData(texture.image);
    });
    stadiumTextureStadium.colorSpace = THREE.SRGBColorSpace;
    stadiumTextureStadium.minFilter = THREE.LinearFilter;
    stadiumTextureStadium.magFilter = THREE.LinearFilter;
    stadiumTextureStadium.generateMipmaps = false;

    const stadiumMaterialStadium = new THREE.MeshBasicMaterial({
        map: stadiumTextureStadium,
        transparent: true,
    });
    stadiumPlaneStadium = new THREE.Mesh(
        new THREE.PlaneGeometry(essenceStadiumWidth, essenceStadiumHeight),
        stadiumMaterialStadium
    );
    stadiumPlaneStadium.position.z = -0.0003; // Detrás del blackPlane (-0.02)

    stadiumPlaneStadium.scale.set(1, 1, 1);

    if (isMobile) {
        stadiumPlaneStadium.opacity = 0;
    }

    stadiumStadiumGroup = new THREE.Group();

    stadiumFrontGroup = new THREE.Group();

    stadiumFrontGroup.scale.set(16, 16, 1);
    stadiumFrontGroup.add(stadiumPlaneFront);
    stadiumFrontGroup.add(stadiumPlaneDegradation);
    stadiumStadiumGroup.add(stadiumPlaneStadium);
    stadiumFrontGroup.add(stadiumStadiumGroup);

    stadiumFrontPositionGroup = new THREE.Group();
    stadiumFrontPositionGroup.position.y = -visibleHeight * 1.5; // ajusta el 0.4 a ojo
    stadiumFrontPositionGroup.position.x = -visibleWidth * 1.5; // ajusta el 0.4 a ojo
    stadiumFrontPositionGroup.add(stadiumFrontGroup);


    scene.add(stadiumFrontPositionGroup);

    stadiumBackGroup = new THREE.Group();
    if (isMobile) {
        stadiumBackGroup.add(stadiumBlackPlane);
    }
    stadiumBackGroup.add(stadiumPlaneBack);
    scene.add(stadiumBackGroup);

    let stadiumTextureLightImage = '/resources/the10stadium_light.webp';
    if (isMobile) {
        stadiumTextureLightImage = '/resources/the10stadium_mobile_light.webp';
    }
    const stadiumTextureLight = textureLoader.load(stadiumTextureLightImage);
    stadiumTextureLight.colorSpace = THREE.SRGBColorSpace;
    stadiumTextureLight.minFilter = THREE.LinearFilter;
    stadiumTextureLight.magFilter = THREE.LinearFilter;
    stadiumTextureLight.generateMipmaps = false;

    stadiumMaterialLight = new THREE.MeshBasicMaterial({
        map: stadiumTextureLight,
        transparent: true,
        opacity: 0
    });

    stadiumPlaneLight = new THREE.Mesh(
        new THREE.PlaneGeometry(essenceStadiumWidth, essenceStadiumHeight),
        stadiumMaterialLight
    );
    stadiumPlaneLight.position.copy(stadiumPlaneStadium.position);
    stadiumPlaneLight.scale.copy(stadiumPlaneStadium.scale);
    stadiumPlaneLight.position.z = stadiumPlaneStadium.position.z + 0.0001; // un pelín delante

    stadiumStadiumGroup.add(stadiumPlaneLight);

    let stadiumTextureArenaImage = '/resources/the10stadium_arena.webp';
    if (isMobile) {
        stadiumTextureArenaImage = '/resources/the10stadium_mobile_arena.webp';
    }
    const stadiumTextureArena = textureLoader.load(stadiumTextureArenaImage);
    stadiumTextureArena.colorSpace = THREE.SRGBColorSpace;
    stadiumTextureArena.minFilter = THREE.LinearFilter;
    stadiumTextureArena.magFilter = THREE.LinearFilter;
    stadiumTextureArena.generateMipmaps = false;

    stadiumMaterialArena = new THREE.MeshBasicMaterial({
        map: stadiumTextureArena,
        transparent: true,
        opacity: 1
    });

    stadiumPlaneArena = new THREE.Mesh(
        new THREE.PlaneGeometry(essenceStadiumWidth, essenceStadiumHeight),
        stadiumMaterialArena
    );
    stadiumPlaneArena.position.copy(stadiumPlaneStadium.position);
    stadiumPlaneArena.scale.copy(stadiumPlaneStadium.scale);
    stadiumPlaneArena.position.z = stadiumPlaneStadium.position.z + 0.0001; // un pelín delante



    stadiumPlaneArenaWrapper = new THREE.Group();
    stadiumPlaneArenaWrapper.add(stadiumPlaneArena);

    stadiumStadiumGroup.add(stadiumPlaneArenaWrapper);
    startArenaGlitchLoop();

    let stadiumTextureScrollBGImage = '/resources/the10stadium_bg2.webp';
    if (isMobile) {
        stadiumTextureScrollBGImage = '/resources/the10stadium_mobile_bg2.webp';
    }
    const stadiumTextureScrollBG = textureLoader.load(stadiumTextureScrollBGImage);
    stadiumTextureScrollBG.colorSpace = THREE.SRGBColorSpace;
    stadiumTextureScrollBG.minFilter = THREE.LinearFilter; // Changed from NearestFilter
    stadiumTextureScrollBG.magFilter = THREE.LinearFilter; // Changed from NearestFilter
    stadiumTextureScrollBG.anisotropy = renderer.capabilities.getMaxAnisotropy(); // Add anisotropic filtering
    stadiumTextureScrollBG.generateMipmaps = false; // Changed from true

    const stadiumMaterialScrollBG = new THREE.MeshBasicMaterial({
        map: stadiumTextureScrollBG,
        transparent: false,
        opacity: 1
    });

    scrollBGPlane = new THREE.Mesh(
        new THREE.PlaneGeometry((visibleWidth), (visibleWidth) * 4950 / 2560),
        stadiumMaterialScrollBG
    );

// Lo posicionamos muy abajo para que suba después
    const scrollBGY = visibleWidth/visibleHeight  * -2.7 ;
    scrollBGPlane.position.set(0, scrollBGY, -0.0006);
    stadiumFrontPositionGroup.add(scrollBGPlane);

    // Texto "CREEMOS"
    textPlaneBelieve = createTextPlane(believeText, 210);
    textPlaneBelieve.opacity = 0;
    textPlaneBelieve.rotation.z = Math.PI / 2;
    textPlaneBelieve.scale.set(visibleHeight * 0.6, visibleHeight * 0.6, 1);
    textPlaneBelieve.position.set(-visibleWidth * 0.35, visibleHeight / 2 - 1.5, -0.00055); // posición inicial
    scene.add(textPlaneBelieve);

    createEssenceTextPlanes();

    // Iniciar las animaciones una vez que todo está cargado
    initAnimations();
    syncAnimationWithVideo();
    animate();
    initStarsScrollTrigger();
    initLegendsScrollTrigger();
    setTimeout(checkInitialStarsPosition, 100);
});

window.addEventListener('load', () => {
    setTimeout(checkInitialStarsPosition, 200);
});

// Inicializar animaciones con GSAP y ScrollTrigger
function initAnimations() {
    function getAlignmentOffset(key) {
        if (window.essenceAlignmentData && window.essenceAlignmentData[key]) {
            return window.essenceAlignmentData[key].alignmentOffset;
        }
        console.warn(`⚠️ Alignment data not ready for ${key}, using 0`);
        return 0; // Fallback si los datos no están listos
    }
    const isMobile = isMobileDevice();
    const baseCenterY = 0;
    // Fase A (intro de letras) - ahora es automática

    // Animaciones de letras (idéntico a antes)
    const introPure = document.querySelector('.word-pure');
    const introFootball = document.querySelector('.word-football');
    const introEffort = document.querySelector('.word-effort');
    const introTalent = document.querySelector('.word-talent');
    const weBelieverInWrapper = document.querySelector('.we-belive-in-wrapper');
    const logoBlock = document.querySelector('.logo-initial-block');
    const essenceBelieve = document.querySelector('.believe-lateral');
    const essenceFirstWords = document.querySelector('.essence-words.first');
    const essenceSecondWords = document.querySelector('.essence-words.second');
    const essenceThirdWords = document.querySelector('.essence-words.third');
    const essenceFourthWords = document.querySelector('.essence-words.fourth');

    const wrapperTimeline = gsap.timeline();
    wrapperTimeline
        .fromTo(weBelieverInWrapper, { opacity: 0 }, { opacity: 1, duration: 1.6 })
        .to(weBelieverInWrapper, { opacity: 0, duration: 0 }, 17.7);

    const pureTimeline = gsap.timeline();
    pureTimeline
        .fromTo(introPure, { opacity: 0 }, { opacity: 1, duration: 0.5 })
        .to(introPure, { opacity: 0, duration: 0 }, 2.9);

    const footballTimeline = gsap.timeline();
    footballTimeline
        .fromTo(introFootball, { opacity: 0 }, { opacity: 1, duration: 0.5 })
        .to(introFootball, { opacity: 0, duration: 0 }, 4.5);

    const effortTimeline = gsap.timeline();
    effortTimeline
        .fromTo(introEffort, { opacity: 0 }, { opacity: 1, duration: 0.5 })
        .to(introEffort, { opacity: 0, duration: 0 }, 5.9);


    const talentTimeline = gsap.timeline();
    talentTimeline
        .fromTo(introTalent, { opacity: 0 }, { opacity: 1, duration: 0.5 })
        .to(introTalent, { opacity: 0, duration: 0 }, 2.9);

    const logoTimeline = gsap.timeline();
    logoTimeline
        .fromTo(logoBlock, { opacity: 0}, { opacity: 1, duration: 0.01})
        .fromTo(logoBlock, { top: "50vh", scale: 1}, { top: "50vh", scale: 1.5, duration: 5.5})
        .to(logoBlock, { opacity: 0, duration: 0 }, 5.5);

    // Unimos todas las animaciones en orden
    phaseATimeline
        .add(wrapperTimeline, 0.8)
        .add(pureTimeline, 2.3)
        .add(footballTimeline, 5.2)
        .add(effortTimeline, 9.7)
        .add(talentTimeline, 15.6)
        .add(logoTimeline, 21.1);

    // Recogemos todos los elementos de texto para la animación de transición
    const videoElements = document.querySelector('.video-elements');

    // Fase B (paneles), activada por scroll pero ahora con una etapa de transición para los textos
    phaseBTimeline = gsap.timeline({
        scrollTrigger: {
            trigger: ".spacer",
            start: "top top",
            end: "bottom bottom",
            scrub: 1.5,
            onUpdate: self => {
                const progress = self.progress;

                // NUEVO: Precargar Stars cuando estamos en la mitad de Essence
                if (progress > 0.6 && !starsPreloadTriggered) {
                    starsPreloadTriggered = true;
                    preloadStarsSection();
                }

                const hoverStartTime = phaseBTimeline.labels['stadiumReady'];
                const hoverEndTime = phaseBTimeline.labels['stadiumTooReady'];
                const currentTime = phaseBTimeline.time();

                if (!hoverStartTime || !hoverEndTime) {
                    console.warn("Los labels 'stadiumReady' o 'stadiumTooReady' no están definidos en el timeline.");
                    return;
                }

                const hoverDuration = hoverEndTime - hoverStartTime;
                const progressAfterHover = (currentTime - hoverStartTime) / hoverDuration;

                if (progressAfterHover >= 0 && progressAfterHover <= 1 && !essenceHoverEnabled) {
                    essenceHoverEnabled = true;
                    canvas.classList.add('canvas-interactive');
                    document.body.style.cursor = 'pointer';
                }

                if ((progressAfterHover < 0 || progressAfterHover > 1) && essenceHoverEnabled) {
                    essenceHoverEnabled = false;
                    canvas.classList.remove('canvas-interactive');
                    document.body.style.cursor = 'auto';
                }
            }
        }
    });

    // Dividimos el timeline en etapas
    // Etapa 1: Los textos se desplazan hacia arriba (0% - 30% del scroll)
    if (isMobile) {
        phaseBTimeline
            .to(videoElements, { y: "-75vh", scale: 1.02, duration: 0.3, ease: "power2.inOut" }, 0)
            .to(borderMeshes.map(m => m.material), { opacity: 0.3, duration: 0.1, ease: "power2.inOut" }, 0)
            .to('#scrolldown', {opacity: 0, duration: 0.1, ease: "power2.inOut" }, 0)
            .to(fullPlane.material, { opacity: 0, duration: 0.3, ease: "power2.inOut" }, 0.3)
            .to(borderMeshes.map(m => m.material), { opacity: 0, duration: 0.3, ease: "power2.inOut" }, 0.3)
            .call(() => {
                planes.forEach(p => p.visible = true);
            }, null, 0.3)
            .to(logoMesh.position, { y: 0, duration: 0.3, ease: "power2.out" })

            .to(planes[0].position, { y: visibleHeight, duration: 0.15 }, 0.75)
            .to(planes[2].position, { y: visibleHeight * -1, duration: 0.15 }, 0.75)
            .to(planes[1].position, { z: 2.001, duration: 0.5 }, 0.9)
            .to(planes[1], { visible: false, duration: 0.01 }, 1.15)
            .to(blackPlane, { visible: false, duration: 0.01 }, 1.15)
            .to(logoMesh.position, { z: 2.002, duration: 0.5 }, 0.9)
            .to(stadiumPlaneBack.scale, { x: 1.01, y: 1.01, duration: 1.2, ease: "expo.out" }, 0.8)
            .to(stadiumFrontGroup.scale, { x: 1.05, y: 1.05, duration: 1.2, ease: "expo.out" }, 0.8)
            .to(stadiumPlaneBack.position, {
                y: visibleHeight * 0.45,
                x: 0,
                duration: 1.2,
                ease: "expo.out"
            }, 0.8)
            .to(stadiumFrontPositionGroup.position, {
                y: visibleHeight * 0.25,
                x: 0,
                duration: 1.2,
                ease: "expo.out"
            }, 0.8)
            .to(stadiumPlaneLight.material, { opacity: 1, duration: 0.2}, 1.8)
            .to(stadiumPlaneBack.material, { opacity: 0.5, duration: 0.2}, 1.8)
            .addLabel('stadiumReady', 1.8)
            .addLabel('stadiumTooReady', 2.6)
            .to(stadiumBlackPlane.position, {
                y: visibleHeight * 0.9,
                x: 0,
                duration: 0.7,
                ease: "none"
            }, 2)
            .to(stadiumPlaneBack.position, {
                y: visibleHeight * 0.9,
                duration: 0.7,
                ease: "none"
            }, 2)
            .to(stadiumFrontPositionGroup.position, {
                y: visibleHeight * 0.6,
                duration: 0.7,
                ease: "none"
            }, 2)
            .fromTo(textPlaneBelieve.material, {
                opacity: 0
            }, {
                opacity: 1,
                duration: 0.1
            }, 0.8)
            .fromTo(textPlaneBelieve.position, {
                y: visibleHeight * 0.5
            }, {
                y: visibleHeight * -0.05,
                duration: 0.9
            }, 0.8)

            // ANIMACIONES RESPONSIVAS DE ESSENCE WORDS - MÓVIL (AJUSTADAS)
            .fromTo(essenceTextPlanes.first.position,
                {
                    x: visibleWidth * 1.1,
                    y: visibleHeight * 0.9 + getAlignmentOffset('first')
                },
                {
                    keyframes: {
                        "40%": {
                            x: visibleWidth * 0.1,
                            y: visibleHeight * -0.2 + getAlignmentOffset('first')
                        },
                        "100%": {
                            x: visibleWidth * 0.1,
                            y: visibleHeight * 0.25 + getAlignmentOffset('first')
                        }
                    },
                    duration: 2.5,
                    ease: "sine.inOut"
                },
                0.7
            )
            .fromTo(essenceTextPlanes.first.material,
                {opacity: 0},
                {
                    opacity: 1,
                    duration: 0.1,
                    ease: "sine.inOut"
                },
                0.5
            )

            // ESSENCE SECOND WORDS - Con offset de alineación
            .fromTo(essenceTextPlanes.second.position,
                {
                    x: visibleWidth * -1.5,
                    y: visibleHeight * -1.1 + getAlignmentOffset('second')
                },
                {
                    x: visibleWidth * 0.1,
                    y: visibleHeight * 0.06 + getAlignmentOffset('second'),
                    duration: 1.1,
                    ease: "sine.inOut"
                },
                1.7
            )
            .fromTo(essenceTextPlanes.second.material,
                {opacity: 0},
                {
                    keyframes: {
                        "50%": {opacity: 0.7},
                        "100%": {opacity: 1}
                    },
                    duration: 1,
                    ease: "sine.inOut"
                },
                1.7
            )

            // ESSENCE THIRD WORDS - Con offset de alineación
            .fromTo(essenceTextPlanes.third.position,
                {
                    x: visibleWidth * 1.5,
                    y: visibleHeight * -1.1 + getAlignmentOffset('third')
                },
                {
                    x: visibleWidth * 0.1,
                    y: visibleHeight * -0.14 + getAlignmentOffset('third'),
                    duration: 1,
                    ease: "sine.inOut"
                },
                1.9
            )
            .fromTo(essenceTextPlanes.third.material,
                {opacity: 0},
                {
                    opacity: 1,
                    duration: 0.1,
                    ease: "sine.inOut"
                },
                1.9
            )

            // ESSENCE FOURTH WORDS - Con offset de alineación (se queda centrado)
            .fromTo(essenceTextPlanes.fourth.position,
                {
                    x: visibleWidth * -1.5,
                    y: visibleHeight * -1.1 + getAlignmentOffset('fourth')
                },
                {
                    x: visibleWidth * 0.1,
                    y: visibleHeight * -0.33 + getAlignmentOffset('fourth'), // Se queda centrado
                    duration: 1.2,
                    ease: "sine.inOut"
                },
                2.1
            )
            .fromTo(essenceTextPlanes.fourth.material,
                {opacity: 0.3},
                {
                    opacity: 1,
                    duration: 0.1,
                    ease: "sine.inOut"
                },
                2.1
            );

    } else {
        phaseBTimeline
            .to(videoElements, { y: "-75vh", scale: 1.05, duration: 0.3, ease: "power2.inOut" }, 0)
            .to(borderMeshes.map(m => m.material), { opacity: 0.3, duration: 0.1, ease: "power2.inOut" }, 0)
            .to('#scrolldown', {opacity: 0, duration: 0.1, ease: "power2.inOut" }, 0)
            .to(fullPlane.material, { opacity: 0, duration: 0.3, ease: "power2.inOut" }, 0.3)
            .to(borderMeshes.map(m => m.material), { opacity: 0, duration: 0.3, ease: "power2.inOut" }, 0.3)
            .call(() => {
                planes.forEach(p => p.visible = true);
            }, null, 0.3)
            .to(logoMesh.position, { y: 0, duration: 0.3, ease: "power2.out" })
            .to([planes[0].position, planes[2].position], { y: visibleHeight, duration: 0.15 }, 0.75)
            .to(planes[1].position, { z: 2.001, duration: 0.5 }, 0.9)
            .to(planes[1], { visible: false, duration: 0.01 }, 1.15)
            .to(blackPlane, { visible: false, duration: 0.01 }, 1.15)
            .to(logoMesh.position, { z: 2.002, duration: 0.5 }, 0.9)
            .to(stadiumPlaneBack.scale, { x: 1.01, y: 1.01, duration: 1.2, ease: "expo.out" }, 0.9)
            .to(stadiumFrontGroup.scale, { x: 1.05, y: 1.05, duration: 1.2, ease: "expo.out" }, 0.9)
            .to(stadiumFrontPositionGroup.position, {
                y: 0,
                x: 0,
                duration: 1.2,
                ease: "expo.out"
            }, 0.9)
            .addLabel('stadiumReady', 1.8)
            .addLabel('stadiumTooReady', 2.6)
            .to([stadiumFrontPositionGroup.position, stadiumPlaneBack.position], {
                y: visibleHeight * 2,
                duration: 2,
                ease: "none"
            }, 2.5)
            .to(scrollBGPlane.position, {
                keyframes: {
                    "40%": {y: visibleWidth/visibleHeight * -2.5},
                    "100%": {y: visibleWidth/visibleHeight * -0.9}
                },
                duration: 3.5,
                ease: "none"
            }, 2.5)
            .fromTo(textPlaneBelieve.material, {
                opacity: 0
            }, {
                opacity: 1,
                duration: 0.1
            }, 2.8)
            .fromTo(textPlaneBelieve.position, {
                y: visibleHeight * 0.5
            }, {
                y: visibleHeight * -0.05,
                duration: 0.9
            }, 2.6)

            // NUEVAS ANIMACIONES DE ESSENCE WORDS EN CANVAS
            // ESSENCE FIRST WORDS
            .fromTo(essenceTextPlanes.first.position,
                {
                    x: visibleWidth * 0.5,
                    y: visibleHeight * 0.1 + getAlignmentOffset('first')
                },
                {
                    keyframes: {
                        "30%": {
                            x: visibleWidth * 0.1,
                            y: visibleHeight * -0.2 + getAlignmentOffset('first')
                        },
                        "50%": {
                            x: visibleWidth * 0.1,
                            y: visibleHeight * 0.2 + getAlignmentOffset('first')
                        },
                        "100%": {
                            x: visibleWidth * -2,
                            y: visibleHeight * 1.05 + getAlignmentOffset('first')
                        }
                    },
                    duration: 3,
                    ease: "sine.inOut"
                },
                2.15
            )
            .fromTo(essenceTextPlanes.first.material,
                {opacity: 0},
                {
                    keyframes: {
                        "20%": {opacity: 1},
                        "55%": {opacity: 1},
                        "60%": {opacity: 0.3}
                    },
                    duration: 3,
                    ease: "sine.inOut"
                },
                2.15
            )

            // ESSENCE SECOND WORDS - Con offset de alineación
            .fromTo(essenceTextPlanes.second.position,
                {
                    x: visibleWidth * -2,
                    y: visibleHeight * -1.45 + getAlignmentOffset('second')
                },
                {
                    keyframes: {
                        "28%": {
                            x: visibleWidth * 0.1,
                            y: visibleHeight * -0.2 + getAlignmentOffset('second')
                        },
                        "55%": {
                            x: visibleWidth * 0.1,
                            y: visibleHeight * 0.2 + getAlignmentOffset('second')
                        },
                        "100%": {
                            x: visibleWidth * 2,
                            y: visibleHeight * 1 + getAlignmentOffset('second')
                        }
                    },
                    duration: 3.4,
                    ease: "sine.inOut"
                },
                2.45
            )
            .fromTo(essenceTextPlanes.second.material,
                {opacity: 0},
                {
                    keyframes: {
                        "18%": {opacity: 0.3},
                        "28%": {opacity: 1},
                    },
                    duration: 3.4,
                    ease: "sine.inOut"
                },
                2.45
            )

            // ESSENCE THIRD WORDS - Con offset de alineación
            .fromTo(essenceTextPlanes.third.position,
                {
                    x: visibleWidth * 2,
                    y: visibleHeight * -1.15 + getAlignmentOffset('third')
                },
                {
                    keyframes: {
                        "50%": {
                            x: visibleWidth * 0.1,
                            y: visibleHeight * -0.2 + getAlignmentOffset('third')
                        },
                        "100%": {
                            x: visibleWidth * 0.1,
                            y: visibleHeight * 0.2 + getAlignmentOffset('third')
                        }
                    },
                    duration: 2.2,
                    ease: "sine.inOut"
                },
                3.2
            )
            .fromTo(essenceTextPlanes.third.material,
                {opacity: 0},
                {
                    keyframes: {
                        "20%": {opacity: 1},
                        "100%": {opacity: 1}
                    },
                    duration: 2.2,
                    ease: "sine.inOut"
                },
                3.2
            )

            // ESSENCE FOURTH WORDS - Con offset de alineación
            .fromTo(essenceTextPlanes.fourth.position,
                {
                    x: visibleWidth * -2,
                    y: visibleHeight * -1.15 + getAlignmentOffset('fourth')
                },
                {
                    x: visibleWidth * 0.1,
                    y: visibleHeight * -0.2 + getAlignmentOffset('fourth'),
                    duration: 1.4,
                    ease: "sine.inOut"
                },
                3.65
            )
            .fromTo(essenceTextPlanes.fourth.material,
                {opacity: 0.3},
                {
                    opacity: 1,
                    duration: 1,
                    ease: "sine.inOut"
                },
                4.45
            );
    }


}

function pixelsToThreeJS(pixels) {
    return (pixels / window.innerHeight) * visibleHeight;
}

async function preloadStarsSection() {
    if (starsPreloaded) return;


    try {
        // Precargar texturas primero
        await preloadStarsTextures();

        // Crear el canvas después de un pequeño delay para no bloquear
        setTimeout(() => {
            createStarsCanvas();
            createStarsTimeline();
            starsPreloaded = true;
        }, 100);

    } catch (error) {
        console.warn('⚠️ Error precargando Stars:', error);
        // Fallback: crear de todas formas
        setTimeout(() => {
            createStarsCanvas();
            createStarsTimeline();
            starsPreloaded = true;
        }, 100);
    }
}

function preloadStarsTextures() {
    return new Promise((resolve) => {
        const starsTextures = [
            '/resources/stars-bg3.webp',
            '/resources/stars-stadium2.webp',
            '/resources/stars-screens.webp',
            '/resources/stars-stars.webp',
        ];

        let loadedCount = 0;
        const totalTextures = starsTextures.length;

        const checkComplete = () => {
            loadedCount++;
            if (loadedCount >= totalTextures) {
                resolve();
            }
        };

        starsTextures.forEach(src => {
            const img = new Image();
            img.onload = checkComplete;
            img.onerror = checkComplete; // Continuar aunque algunas fallen
            img.src = src;
        });

        // Timeout de seguridad
        setTimeout(() => {
            if (loadedCount < totalTextures) {
                resolve();
            }
        }, 3000);
    });
}

// RESIZE
window.addEventListener('resize', () => {
    /*
    sizes.width = window.innerWidth;
    sizes.height = window.innerHeight - 50;
    camera.aspect = sizes.width / sizes.height;
    camera.updateProjectionMatrix();
    renderer.setSize(sizes.width, sizes.height);

    if (starsRenderer && starsCamera) {
        starsCamera.aspect = sizes.width / sizes.height;
        starsCamera.updateProjectionMatrix();
        starsRenderer.setSize(sizes.width, sizes.height);
    }

     */
});


const raycaster = new THREE.Raycaster();
const mouse = new THREE.Vector2();

let targetX = 0;
let targetY = 0;
let spTargetX = 0;
let spTargetY = 0;
let spCurrentX = 0;
let spCurrentY = 0;

// Variables para el movimiento de stars
let starsTargetX = 0;
let starsTargetY = 0;
let starsCurrentX = 0;
let starsCurrentY = 0;

const backFactor = 0.02; // movimiento sutil para el fondo
const frontFactor = 0.1; // movimiento un poco más notorio para el frente

// Factores para stars (más sutiles)
const starsBackgroundFactor = 0.1; // movimiento muy sutil para el fondo

function updateStadiumPlanesMovement() {
    const lerp = 0.05;

    spCurrentX += (targetX - spCurrentX) * lerp;
    spCurrentY += (targetY - spCurrentY) * lerp;

    if (stadiumBackGroup) {
        stadiumBackGroup.position.x = spCurrentX * backFactor;
        stadiumBackGroup.position.y = spCurrentY * backFactor;
    }

    if (stadiumFrontGroup) {
        stadiumFrontGroup.position.x = spCurrentX * frontFactor;
        stadiumFrontGroup.position.y = spCurrentY * frontFactor;
    }

}

function updateStarsMovement() {
    const lerp = 0.05; // Un poco más lento que essence para más suavidad

    starsCurrentX += (starsTargetX - starsCurrentX) * lerp;
    starsCurrentY += (starsTargetY - starsCurrentY) * lerp;

    if (starsActive && starsMainGroup) {
        // Mover el fondo de manera muy sutil
        if (starsBackgroundPlane) {
            starsBackgroundPlane.position.x = starsCurrentX * starsBackgroundFactor;
            starsBackgroundPlane.position.y = starsCurrentY * starsBackgroundFactor;
        }
    }
}

function getImageData(image) {
    const canvas = document.createElement('canvas');
    canvas.width = image.width;
    canvas.height = image.height;

    const ctx = canvas.getContext('2d');
    ctx.drawImage(image, 0, 0);

    return ctx.getImageData(0, 0, image.width, image.height);
}

// RENDER LOOP
const animate = () => {
    requestAnimationFrame(animate);

    // Render
    renderer.render(scene, camera);

    if (!isMobileDevice()) {
        updateStadiumPlanesMovement();
        updateStarsMovement();

        // Hover para mostrar luz
        raycaster.setFromCamera(mouse, camera);
        const intersects = raycaster.intersectObject(stadiumPlaneStadium, true);

        let isHovering = false;
        let isPopupVisible = popup?.classList.contains('visible');
        let isMenuOpen = document.body.classList.contains('menu-open');

        if (essenceHoverEnabled && intersects.length > 0 && !isPopupVisible && !isMenuOpen) {
            const intersect = intersects[0];
            const uv = intersect.uv;
            if (uv && stadiumTextureFront.imageData) {
                const x = Math.floor(uv.x * stadiumTextureStadium.imageData.width);
                const y = Math.floor((1 - uv.y) * stadiumTextureStadium.imageData.height); // y invertido
                const index = (y * stadiumTextureStadium.imageData.width + x) * 4;
                const alpha = stadiumTextureStadium.imageData.data[index + 3];

                if (alpha > 50) { // suficiente opacidad
                    //gsap.to(stadiumPlaneFront.scale, { x: 1, y: 1, duration: 0.2 });
                    isHovering = true;
                }
            }
        }

        // Actualiza la clase y el estilo del cursor directamente
        if (isHovering) {
            gsap.to(stadiumPlaneBack.material, { opacity: 0.3, duration: 1.2 });
            gsap.to(stadiumPlaneFront.material, { opacity: 0.3, duration: 1.2 });
            gsap.to(stadiumMaterialLight, { opacity: 1, duration: 1.4, ease: "power2.out" });
            if (!isPopupVisible) {
                popupTitleHoverAnimation = gsap.to(popupTitle, {opacity: 0.6, duration: 0, ease: "power2.out"});
            }
            gsap.to({}, {
                duration: 0.2,
                onStart: () => stadiumPlaneArenaWrapper.visible = false,
                ease: "power2.out"
            });
            canvas.classList.add('canvas-interactive');
            document.body.style.cursor = 'pointer';
        } else {
            gsap.to(stadiumPlaneBack.material, { opacity: 1, duration: 0.3 });
            gsap.to(stadiumPlaneFront.material, { opacity: 1, duration: 0.3 });
            gsap.to(stadiumMaterialLight, { opacity: 0, duration: 0.4, ease: "power2.out" });
            if (!isPopupVisible) {
                gsap.to(popupTitle, { opacity: 0, duration: 0.2, ease: "power2.out" });
            }
            gsap.to({}, {
                duration: 0.2,
                onStart: () => stadiumPlaneArenaWrapper.visible = true,
                ease: "power2.out"
            });
            canvas.classList.remove('canvas-interactive');
            document.body.style.cursor = 'auto';
        }

        // Sincroniza estadio iluminado con el principal
        if (stadiumPlaneFront && stadiumPlaneLight) {
            stadiumPlaneLight.position.copy(stadiumPlaneStadium.position);
            stadiumPlaneLight.scale.copy(stadiumPlaneStadium.scale);
        }
    }

};

// Actualiza las coordenadas objetivo al mover el ratón
document.addEventListener('mousemove', (event) => {
    const { innerWidth, innerHeight } = window;

    const xNorm = (event.clientX / innerWidth) * 2 - 1;
    const yNorm = (event.clientY / innerHeight) * 2 - 1;
    targetX = xNorm;
    targetY = yNorm;
    starsTargetX = xNorm;
    starsTargetY = yNorm;

    const rect = canvas.getBoundingClientRect();
    mouse.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
    mouse.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
});

document.addEventListener('click', () => {
    if (!essenceHoverEnabled) return;
    raycaster.setFromCamera(mouse, camera);
    const intersects = raycaster.intersectObject(stadiumPlaneStadium, true);

    if (intersects.length > 0 && !document.body.classList.contains('popup-open')) {
        const intersect = intersects[0];
        const uv = intersect.uv;
        if (uv && stadiumTextureFront.imageData) {
            const x = Math.floor(uv.x * stadiumTextureStadium.imageData.width);
            const y = Math.floor((1 - uv.y) * stadiumTextureStadium.imageData.height);
            const index = (y * stadiumTextureStadium.imageData.width + x) * 4;
            const alpha = stadiumTextureStadium.imageData.data[index + 3];

            if (alpha > 50) {
                document.querySelector('.popup')?.classList.add('visible');
                document.body.classList.add('popup-open');
                document.documentElement.classList.add('popup-open');
                gsap.fromTo(".popup-content p",
                    {
                        y: 150,
                        x: 150,
                        opacity: 0,
                    },
                    {
                        y: 0,
                        x: 0,
                        opacity: 1,
                        duration: 1.5,
                        delay: 1,
                        ease: "power4",
                        stagger: 0.6
                    }
                );

                let popupTitleFontSize = "90px";
                if (isMobileDevice()) {
                    popupTitleFontSize = "55px";
                }

                //const splitTitle = SplitText.create(popupTitle, { type: "chars" });
                popupTitleAnimation = gsap.to(popupTitle,
                    {
                        opacity: 1,
                        top: "10lvh",
                        left: "50vw",
                        fontSize: popupTitleFontSize,
                        rotationX: 0,
                        rotationZ: 0,
                        rotationY: 0,
                        duration: 1,
                        color: "white",
                        textShadow: "0px 0px 25px rgba(255, 255, 255, 0)",
                        ease: "power3.in",
                        stagger: 0.04
                    }
                );
            }
        }
    }
});


function syncAnimationWithVideo() {
    requestAnimationFrame(syncAnimationWithVideo);

    if (!resourcesLoaded || !video || video.paused) return;

    const t = video.currentTime;

    // Actualiza el timeline a la posición deseada (tiempo relativo)
    phaseATimeline.time(t);
}

document.addEventListener('DOMContentLoaded', function() {
    // Elementos DOM
    const menuButton = document.querySelector('.menu-button');
    const menuOverlay = document.getElementById('menu-overlay');
    const menuLinks = document.querySelectorAll('.menu-link');
    const menuLinkTexts = document.querySelectorAll('.menu-link-text');
    const body = document.body;

    // Asignar índices para animación escalonada de los elementos del menú
    const menuItems = document.querySelectorAll('.menu-nav li');
    menuItems.forEach((item, index) => {
        item.style.setProperty('--i', index);
    });

    // Función para alternar el menú
    function toggleMenu() {
        menuButton.classList.toggle('open');
        menuOverlay.classList.toggle('active');
        body.classList.toggle('menu-open');
        document.documentElement.classList.toggle('menu-open');

        if (menuOverlay.classList.contains('active')) {
            gsap.fromTo(menuLinkTexts,
                {
                    y: '150%'
                },
                {
                    y: '0%',
                    duration: 1.5,
                    stagger: 0.08,
                    ease: "power3.out"
                }
            );
        } else {
            gsap.to(menuLinkTexts,
                {
                    y: '100%'
                }
            );
        }

        // Si el menú se abre, pausamos el video para mejor rendimiento
        const video = document.querySelector('video');
        if (video) {
            if (menuOverlay.classList.contains('active')) {
                // Almacenamos el estado actual del video
                video.dataset.wasPlaying = !video.paused;
                video.pause();
            } else {
                // Restauramos el estado del video
                if (video.dataset.wasPlaying === 'true') {
                    video.play().catch(e => console.warn("No se pudo reproducir el video:", e));
                }
            }
        }
    }

    // Event listeners

    menuButton.addEventListener('click', (e) => {
        e.preventDefault();
        toggleMenu();
    });

    // Cierra el menú al hacer clic en los enlaces
    menuLinks.forEach(link => {
        link.addEventListener('click', () => {
            toggleMenu();
        });
    });

    // Cierra el menú con la tecla Escape
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && menuOverlay.classList.contains('active')) {
            toggleMenu();
        }
    });

    const popupCloseButton = document.querySelector('.popup-close-button');

    popupCloseButton?.addEventListener('click', () => {
        popup?.classList.remove('visible');
        document.body.classList.remove('popup-open');
        document.documentElement.classList.remove('popup-open');
        popupTitleAnimation.reverse();
    });

    setupMenuNavigation();
    const submitButton = document.querySelector('.wpcf7-form .submit-button');
    if (submitButton) {
        submitButton.innerHTML = 'Submit <svg class="submit-arrow" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 17L17 7M17 7H7M17 7V17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    }
});

function startArenaGlitchLoop() {
    const glitchTimeline = gsap.timeline({ repeat: -1, repeatDelay: 1 });

    glitchTimeline
        .to(stadiumMaterialArena, { opacity: 1, duration: 0.4, ease: "power2.inOut" })
        .to(stadiumMaterialArena, { opacity: 0.7, duration: 0.05, ease: "none" })
        .to(stadiumMaterialArena, { opacity: 1, duration: 0.05, ease: "none" })
        .to(stadiumMaterialArena, { opacity: 0.2, duration: 0.03, ease: "none" })
        .to(stadiumMaterialArena, { opacity: 1, duration: 0.1, ease: "none" })
        .to(stadiumMaterialArena, { opacity: 0, duration: 0.8, ease: "sine.inOut" });
}
function createTextPlane(text, fontSize = 120, strokeColor = 'white', strokeWidth = 2) {
    const dpr = window.devicePixelRatio || 1;
    const isMobile = isMobileDevice();

    // Hacer el fontSize responsive
    if (isMobile && fontSize > 50) {
        fontSize = Math.max(30, fontSize * 0.4); // Reducir en móvil
    } else if (window.innerWidth < 1200 && fontSize > 50) {
        fontSize = Math.max(40, fontSize * 0.6); // Reducir en tablets
    }

    // Crear un contexto temporal para medir el texto
    const tempCanvas = document.createElement('canvas');
    const tempCtx = tempCanvas.getContext('2d');
    tempCtx.font = `bold ${fontSize}px InterStatic, sans-serif`;
    const textMetrics = tempCtx.measureText(text);

    const padding = strokeWidth * 4;
    const textWidth = textMetrics.width + padding * 2;
    const textHeight = fontSize * 1.5 + padding * 2;

    const canvas = document.createElement('canvas');
    canvas.width = textWidth * dpr;
    canvas.height = textHeight * dpr;

    const ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);

    ctx.font = `bold ${fontSize}px InterStatic, sans-serif`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';

    const centerX = textWidth / 2;
    const centerY = textHeight / 2;

    ctx.lineWidth = strokeWidth;
    ctx.strokeStyle = strokeColor;
    ctx.strokeText(text, centerX, centerY);

    ctx.fillStyle = 'rgba(0,0,0,0)';
    ctx.fillText(text, centerX, centerY);

    const texture = new THREE.CanvasTexture(canvas);
    texture.minFilter = THREE.LinearFilter;
    texture.magFilter = THREE.LinearFilter;
    texture.generateMipmaps = false;

    const aspect = canvas.width / canvas.height;

    // Tamaño responsive
    let width;
    if (isMobile) {
        width = Math.min(2.5, visibleWidth * 0.6); // Más pequeño en móvil
    } else {
        width = 1.5;
    }

    const height = width / aspect;

    const geometry = new THREE.PlaneGeometry(width, height);
    return new THREE.Mesh(geometry, new THREE.MeshBasicMaterial({
        map: texture,
        transparent: true
    }));
}


// Nuevo método para crear los bloques de texto "essence" con alineación izquierda, tamaño uniforme, salto de línea y altura consistente

function createEssenceTextPlanes() {

    const dpr = window.devicePixelRatio || 1;
    const isMobile = isMobileDevice();

    const baseWidth = isMobile ? visibleWidth * 0.7 : 3.5;
    const fontSizeTitle = isMobile ? 22 : 50;
    const fontSizeSubtitle = isMobile ? 14 : 25;
    const lineHeight = 1.1;
    const padding = 20;
    const sectionSpacing = isMobile ? 5 : 20;

    Object.entries(essenceData).forEach(([key, sections]) => {
        const tempCanvas = document.createElement('canvas');
        const ctx = tempCanvas.getContext('2d');

        ctx.font = `bold ${fontSizeTitle}px Inter, sans-serif`;
        const maxPxWidth = baseWidth * 300;

        const lines = [];
        sections.forEach(({ title, subtitle }) => {
            ctx.font = `bold ${fontSizeTitle}px Inter, sans-serif`;
            wrapText(title, maxPxWidth, ctx).forEach(line => lines.push({ text: line, font: fontSizeTitle, bold: true }));
            lines.push({ spacer: true });
            ctx.font = `${fontSizeSubtitle}px Inter, sans-serif`;
            wrapText(subtitle, maxPxWidth, ctx).forEach(line => lines.push({ text: line, font: fontSizeSubtitle, bold: false }));
            lines.push({ spacer: true });
            lines.push({ spacer: true });
            lines.push({ spacer: true });
        });

        const canvasWidth = maxPxWidth + padding * 2;
        const canvasHeight = (lines.length * fontSizeSubtitle * lineHeight) + padding * 2;

        const canvas = document.createElement('canvas');
        canvas.width = canvasWidth * dpr;
        canvas.height = canvasHeight * dpr;

        const renderCtx = canvas.getContext('2d');
        renderCtx.scale(dpr, dpr);
        renderCtx.fillStyle = 'white';
        renderCtx.textAlign = 'left';
        renderCtx.textBaseline = 'top';

        let y = padding;
        lines.forEach(line => {
            if (line.spacer) {
                y += sectionSpacing;
                return;
            }
            renderCtx.font = `${line.bold ? 'bold ' : ''}${line.font}px Inter, sans-serif`;
            renderCtx.fillText(line.text, padding, y);
            y += line.font * lineHeight;
        });

        const texture = new THREE.CanvasTexture(canvas);
        texture.minFilter = THREE.LinearFilter;
        texture.magFilter = THREE.LinearFilter;
        texture.generateMipmaps = false;

        const aspect = canvas.width / canvas.height;
        const height = baseWidth / aspect;
        const geometry = new THREE.PlaneGeometry(baseWidth, height);

        const material = new THREE.MeshBasicMaterial({ map: texture, transparent: true, opacity: 0 });
        const mesh = new THREE.Mesh(geometry, material);

        mesh.position.set(visibleWidth * 2, 0, -0.00046); // fuera de pantalla inicialmente
        essenceTextPlanes[key] = mesh;
        scene.add(mesh);
    });

}

function wrapText(text, maxWidth, ctx) {
    const words = text.split(' ');
    const lines = [];
    let current = words[0];
    for (let i = 1; i < words.length; i++) {
        const test = current + ' ' + words[i];
        if (ctx.measureText(test).width < maxWidth) {
            current = test;
        } else {
            lines.push(current);
            current = words[i];
        }
    }
    lines.push(current);
    return lines;
}

function calculateEssenceAlignmentOffsets() {
    // Calcular el centro visual de cada bloque para alinearlos correctamente
    const alignmentData = {};

    Object.keys(essenceTextPlanes).forEach(key => {
        const mesh = essenceTextPlanes[key];
        if (mesh && mesh.geometry) {
            // Calcular bounding box después del escalado
            const bbox = new THREE.Box3().setFromObject(mesh);
            const height = bbox.max.y - bbox.min.y;
            const centerY = (bbox.max.y + bbox.min.y) / 2;

            alignmentData[key] = {
                height: height,
                centerY: centerY,
                offsetFromCenter: centerY // Offset desde el punto de referencia (0,0)
            };
        }
    });

    // Encontrar el centro promedio para usar como referencia
    const centerYValues = Object.values(alignmentData).map(data => data.centerY);
    const avgCenterY = centerYValues.reduce((sum, y) => sum + y, 0) / centerYValues.length;

    // Calcular offsets para alinear todos al mismo nivel visual
    Object.keys(alignmentData).forEach(key => {
        const data = alignmentData[key];
        data.alignmentOffset = avgCenterY - data.centerY;
    });

    return alignmentData;
}



// MODIFICAR la función initStarsContent()
function initStarsContent() {
    let isMobile = isMobileDevice();
    // Crear el grupo principal que contendrá todos los elementos de stars
    starsMainGroup = new THREE.Group();

    // 1. CREAR EL FONDO INTEGRADO EN EL CANVAS
    let starsBackgroundImage = '/resources/stars-bg3.webp';
    if (isMobile) {
        starsBackgroundImage = '/resources/stars-mobile-bg3.webp';
    }
    const starsBackgroundTexture = textureLoader.load(starsBackgroundImage);
    starsBackgroundTexture.colorSpace = THREE.SRGBColorSpace;
    starsBackgroundTexture.minFilter = THREE.LinearFilter;
    starsBackgroundTexture.magFilter = THREE.LinearFilter;
    starsBackgroundTexture.generateMipmaps = false;

    const starsBackgroundMaterial = new THREE.MeshBasicMaterial({
        map: starsBackgroundTexture,
        transparent: false
    });

    const desktopAspect = 1920 / 1080; // ≈ 1.78 (16:9)
    const mobileAspect = 960 / 309; // ≈ 3.11 (panorámico)
    const targetAspect = isMobile ? mobileAspect : desktopAspect;

    // Crear un plano de fondo más grande para cubrir toda la pantalla
    let bgWidth, bgHeight;

// Obtener el aspect ratio actual de la pantalla
    const screenAspect = visibleWidth / visibleHeight;

    if (screenAspect < targetAspect) {
        // Pantalla más ancha que el aspecto objetivo: ajustar por ancho
        bgHeight = visibleHeight * 1.01; // Un poco más grande para cubrir bien
        bgWidth = bgHeight * targetAspect;
    } else {
        // Pantalla más alta que el aspecto objetivo: ajustar por altura
        bgWidth = visibleWidth * 1.01; // Un poco más grande para cubrir bien
        bgHeight = bgWidth / targetAspect;
    }

    starsBackgroundPlane = new THREE.Mesh(
        new THREE.PlaneGeometry(bgWidth, bgHeight),
        starsBackgroundMaterial
    );

    // Posicionar el fondo al fondo del grupo
    starsBackgroundPlane.position.z = -0.001;

    // Añadir el fondo al grupo principal
    starsMainGroup.add(starsBackgroundPlane);

    // 2. CREAR EL ESTADIO (SIN SHADERS - material básico)
    let starsStadiumImage = '/resources/stars-stadium2.webp';
    if (isMobile) {
        starsStadiumImage = '/resources/stars-mobile-stadium2.webp';
    }
    const starsStadiumTexture = textureLoader.load(starsStadiumImage, texture => {
        texture.image.crossOrigin = '';
        starsStadiumTexture.imageData = getImageData(texture.image);
    });
    starsStadiumTexture.colorSpace = THREE.SRGBColorSpace;
    starsStadiumTexture.minFilter = THREE.LinearFilter;
    starsStadiumTexture.magFilter = THREE.LinearFilter;
    starsStadiumTexture.generateMipmaps = false;

    const starsStadiumMaterial = new THREE.MeshBasicMaterial({
        map: starsStadiumTexture,
        transparent: true
    });


    starsStadiumPlane = new THREE.Mesh(
        new THREE.PlaneGeometry(starsStadiumWidth, starsStadiumHeight),
        starsStadiumMaterial
    );

    starsStadiumPlane.position.z = 0.0005;
    starsStadiumPlane.position.y = 0;

    starsStadiumGroup = new THREE.Group();
    starsStadiumGroup.add(starsStadiumPlane);

    // 3. CREAR LAS PANTALLAS (SIN SHADERS - material básico)
    const starsScreensTexture = textureLoader.load('/resources/stars-screens.webp', texture => {
        texture.image.crossOrigin = '';
        starsScreensTexture.imageData = getImageData(texture.image);
    });
    starsScreensTexture.colorSpace = THREE.SRGBColorSpace;
    starsScreensTexture.minFilter = THREE.LinearFilter;
    starsScreensTexture.magFilter = THREE.LinearFilter;
    starsScreensTexture.generateMipmaps = false;

    const starsScreensMaterial = new THREE.MeshBasicMaterial({
        map: starsScreensTexture,
        transparent: true
    });

    starsScreensPlane = new THREE.Mesh(
        new THREE.PlaneGeometry(starsStadiumWidth, starsStadiumHeight),
        starsScreensMaterial
    );

    starsScreensPlane.position.z = 0.0006;
    starsStadiumGroup.add(starsScreensPlane);

// 4. CREAR EL STARS (SIN SHADERS - material básico)
    const starsTitleTexture = textureLoader.load('/resources/stars-stars.webp', texture => {
        texture.image.crossOrigin = '';
        starsTitleTexture.imageData = getImageData(texture.image);
    });
    starsTitleTexture.colorSpace = THREE.SRGBColorSpace;
    starsTitleTexture.minFilter = THREE.LinearFilter;
    starsTitleTexture.magFilter = THREE.LinearFilter;
    starsTitleTexture.generateMipmaps = false;

    const starsTitleMaterial = new THREE.MeshBasicMaterial({
        map: starsTitleTexture,
        transparent: true
    });

    starsTitlePlane = new THREE.Mesh(
        new THREE.PlaneGeometry(starsStadiumWidth, starsStadiumHeight),
        starsTitleMaterial
    );

    starsTitlePlane.position.z = 0.0006;
    starsStadiumGroup.add(starsTitlePlane);

    // 5. AÑADIR EL ESTADIO AL GRUPO PRINCIPAL
    starsMainGroup.add(starsStadiumGroup);

    // 7. AÑADIR A LA ESCENA (SIN EFECTO CORTINA EN LOS ELEMENTOS)
    starsScene.add(starsMainGroup);

    // 8. INICIAR EFECTOS
    startScreensGlitchLoop();

    // 9. CONFIGURAR EL EFECTO CORTINA EN EL CANVAS
}


function startScreensGlitchLoop() {
    const glitchTimeline = gsap.timeline({ repeat: -1, repeatDelay: 0.2 });

    glitchTimeline
        .to(starsScreensPlane.material, { opacity: 1, duration: 0.4, ease: "power2.inOut" })
        .to(starsScreensPlane.material, { opacity: 0.7, duration: 0.05, ease: "none" })
        .to(starsScreensPlane.material, { opacity: 1, duration: 0.05, ease: "none" })
        .to(starsScreensPlane.material, { opacity: 0.2, duration: 0.03, ease: "none" })
        .to(starsScreensPlane.material, { opacity: 1, duration: 0.1, ease: "none" })
        .to(starsScreensPlane.material, { opacity: 1, duration: 0.8, ease: "sine.inOut" });
}

let starsAnimationRunning = false;
// Función para activar/desactivar el canvas de stars
function toggleStarsCanvas(activate) {
    if (activate && !starsActive) {
        starsActive = true;

        // Transición suave de entrada
        starsCanvas.style.visibility = 'visible';

        requestAnimationFrame(() => {
            starsCanvas.style.opacity = '1';
            starsCanvas.style.pointerEvents = 'auto';

            if (isIOSDevice()) {
                forceStarsRender();
            }
        });

        // Iniciar animación si no está corriendo
        if (!starsAnimationRunning) {
            starsAnimationRunning = true;
            animateStars();
        }

    } else if (!activate && starsActive) {
        starsActive = false;
        starsCanvas.style.opacity = '1';
        starsCanvas.style.pointerEvents = 'none';

        // Ocultar después de la transición
        setTimeout(() => {
            if (!starsActive) {
                starsCanvas.style.visibility = 'visible';
            }
        }, 300);

        starsAnimationRunning = false;

        if (iosScrollTimeout) {
            clearTimeout(iosScrollTimeout);
            iosScrollTimeout = null;
        }
        if (iosRenderInterval) {
            clearInterval(iosRenderInterval);
            iosRenderInterval = null;
        }
    }
}

// Función de renderizado para el canvas de stars
function animateStars() {
    if (!starsActive || !starsRenderer || !starsAnimationRunning) return;

    if (isIOSDevice()) {
        requestAnimationFrame(() => {
            if (starsActive && starsRenderer && starsAnimationRunning) {
                try {
                    starsRenderer.render(starsScene, starsCamera);
                    animateStars(); // Recursión controlada
                } catch (e) {
                    console.warn('Error rendering stars on iOS:', e);
                    // Reintentar después de un momento
                    setTimeout(() => {
                        if (starsActive) animateStars();
                    }, 16);
                }
            }
        });
    } else {
        requestAnimationFrame(animateStars);
        starsRenderer.render(starsScene, starsCamera);
    }
}
// Modificar la función de resize para incluir el canvas de stars
function updateStarsCanvasSize() {
    if (starsRenderer && starsCamera) {
        starsCamera.aspect = sizes.width / sizes.height;
        starsCamera.updateProjectionMatrix();
        starsRenderer.setSize(sizes.width, sizes.height);
    }
}

let phaseStarsTimeline = undefined;
function initStarsScrollTrigger() {
    phaseStarsTimeline = gsap.timeline({
        scrollTrigger: {
            trigger: ".stars-wrapper",
            start: "top bottom",
            end: "bottom bottom",
            scrub: 1.5,
            onEnter: (self) => {
                // Si no está precargado, crear ahora (fallback)
                if (!starsPreloaded) {
                    createStarsCanvas();
                    createStarsTimeline();
                    starsPreloaded = true;
                }

                toggleStarsCanvas(true);
                document.body.classList.add('stars-ready');

                if (isIOSDevice()) {
                    // Forzar render inicial
                    setTimeout(() => {
                        forceStarsRender();
                    }, 100);
                }

                // Actualizar posición suavemente
                requestAnimationFrame(() => {
                    updateStarsPosition(self);
                });

                setTimeout(() => {
                    if (!isMobileDevice()) {
                        toggleStarCardEffects(true);
                    }
                }, 1500);
            },
            onLeave: () => {
                $('.star-card').hide();
                toggleStarsCanvas(false);
                document.body.classList.remove('stars-ready');
                toggleStarCardEffects(false);

                if (iosRenderInterval) {
                    clearInterval(iosRenderInterval);
                    iosRenderInterval = null;
                }
            },
            onEnterBack: () => {
                $('.star-card').show();
                toggleStarsCanvas(true);
                document.body.classList.add('stars-ready');
                setTimeout(() => {
                    if (!isMobileDevice()) {
                        toggleStarCardEffects(true);
                    }
                }, 500);
            },
            onLeaveBack: () => {
                toggleStarsCanvas(false);
                document.body.classList.remove('stars-ready');
                toggleStarCardEffects(false);
            },
            onUpdate: (self) => {
                if (starsCanvas && starsActive) {
                    updateStarsPosition(self);

                    if (isIOSDevice()) {
                        iosScrolling = true;

                        // Limpiar timeout anterior
                        if (iosScrollTimeout) {
                            clearTimeout(iosScrollTimeout);
                        }

                        // Forzar render durante scroll
                        forceStarsRender();

                        // Configurar timeout para cuando termine el scroll
                        iosScrollTimeout = setTimeout(() => {
                            iosScrolling = false;
                            // Forzar render cuando termine el scroll
                            forceStarsRender();

                            // Iniciar interval de renders frecuentes por un momento
                            if (iosRenderInterval) clearInterval(iosRenderInterval);
                            let renderCount = 0;
                            iosRenderInterval = setInterval(() => {
                                forceStarsRender();
                                renderCount++;
                                if (renderCount >= 10) { // 10 renders extra
                                    clearInterval(iosRenderInterval);
                                    iosRenderInterval = null;
                                }
                            }, 16); // ~60fps
                        }, 150); // Detectar final de scroll
                    }

                }
            }
        }
    });
}

function checkInitialStarsPosition() {
    const starsWrapper = document.querySelector('.stars-wrapper');
    if (!starsWrapper) return;

    const rect = starsWrapper.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    if (rect.top <= windowHeight && rect.bottom >= 0) {

        // Precargar inmediatamente si no está hecho
        if (!starsPreloadTriggered) {
            starsPreloadTriggered = true;
            preloadStarsSection().then(() => {
                // Activar después de precargar
                toggleStarsCanvas(true);
                document.body.classList.add('stars-ready');

                const progress = Math.max(0, Math.min(1, (windowHeight - rect.top) / windowHeight));
                const clipPercentage = progress * 100;

                requestAnimationFrame(() => {
                    if (starsCanvas) {
                        starsCanvas.style.clipPath = `inset(${100 - clipPercentage}% 0 0 0)`;
                        starsCanvas.style.visibility = 'visible';
                        starsCanvas.style.opacity = '1';
                    }
                });
            });
        }
    }
}
function updateStarsPosition(scrollTrigger) {
    const starsWrapper = document.querySelector('.stars-wrapper');
    let progress = 0;

    if (starsWrapper) {
        const rect = starsWrapper.getBoundingClientRect();
        if (rect.top>2000) {
            return;
        }
        const windowHeight = window.innerHeight;

        // FIX: Cálculo más robusto del progress
        // El progress debería ser 1 cuando la sección está completamente visible

        if (rect.bottom <= 0) {
            // La sección ya pasó completamente
            progress = 0;
        } else if (rect.top >= windowHeight) {
            // La sección aún no ha llegado
            progress = 0;
        } else {
            // La sección está parcialmente o completamente visible
            if (rect.top <= 0 && rect.bottom >= windowHeight) {
                // Sección ocupa toda la pantalla o más - progress máximo
                progress = 1;
            } else if (rect.top > 0) {
                // Sección entrando desde abajo
                progress = Math.min(1, (windowHeight - rect.top) / windowHeight);
            } else {
                // Sección saliendo por arriba
                progress = Math.min(1, rect.bottom / windowHeight);
            }
        }

        // SANITY CHECK: Asegurar que progress esté entre 0 y 1
        progress = Math.max(0, Math.min(1, progress));

    }

    // Usar CSS clip-path para crear el efecto cortina
    if (starsCanvas) {
        if (progress >= 0 && progress <= 1) {
            const clipPercentage = progress * 100;
            starsCanvas.style.clipPath = `inset(${100 - clipPercentage}% 0 0 0)`;
            starsCanvas.style.opacity = '1';

        } else {
        }
    }

    if (starsMainGroup) {
        starsMainGroup.position.y = 0;
    }
}

function initStarCardsInteractions() {
    const starCards = document.querySelectorAll('.star-card .star-card-inner');

    starCards.forEach(card => {
        card.addEventListener('mouseenter', () => {
            /*
            gsap.to(card, {
                scale: 1.05,
                duration: 0.3,
                ease: "power2.out"
            });

             */
        });

        card.addEventListener('mouseleave', () => {
            /*
            gsap.to(card, {
                scale: 1,
                duration: 0.3,
                ease: "power2.out"
            });

             */
        });

    });
}

// Inicializar cuando la página carga
document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
        initStarCardsInteractions();
        initStarCardEffects();
    }, 1000);
});

function createStarsTimeline() {
    let isMobile = isMobileDevice();
    const leftCards = document.querySelectorAll('.star-card.left');
    const rightCards = document.querySelectorAll('.star-card.right');

    // CONVERSIONES SIMPLES Y DIRECTAS
    function threejsToCSS_X(threejsX) {
        // Convertir coordenada X de Three.js (-visibleWidth/2 a +visibleWidth/2) a CSS (0% a 100%)
        const normalizedX = (threejsX + visibleWidth/2) / visibleWidth;
        return normalizedX * 100; // porcentaje
    }

    function threejsToCSS_Y(threejsY) {
        // Convertir coordenada Y de Three.js (-visibleHeight/2 a +visibleHeight/2) a CSS (100% a 0%)
        const normalizedY = (threejsY + visibleHeight/2) / visibleHeight;
        return (1 - normalizedY) * 100; // invertir Y y convertir a porcentaje
    }

    function threejsToCSS_Size(threejsSize) {
        // Convertir tamaño de Three.js a vw
        return (threejsSize / visibleWidth) * 100; // en vw
    }

    // USAR EXACTAMENTE LAS MISMAS VARIABLES QUE EN THREE.JS
    // En tu código Three.js tenías:
    // const cardSize = visibleWidth / 5;
    // let starScale = 0.185;

    const cardSizeThreeJS = visibleWidth / 2.5;
    const starScaleThreeJS = isMobile ? 2 : 0.65;

    // Posiciones Three.js (las que usabas para las cartas 3D)
    const leftXThreeJS = starsStadiumWidth * -0.1165;
    let leftYThreeJS = starsStadiumHeight * -0.127;
    const rightXThreeJS = starsStadiumWidth * 0.104;
    const rightYThreeJS = starsStadiumHeight * -0.129;

    let minCardScale = 0.1;
    if (isMobile) {
        minCardScale = 0.000274 * window.innerHeight + 0.1147;
        leftYThreeJS = starsStadiumHeight * -0.117 * (window.innerHeight/667 / 1.1);
    }

    let footerPercentage = 40 * 100 / window.innerHeight;

    // CONVERTIR A CSS
    const cardData = {
        left: {
            x: threejsToCSS_X(leftXThreeJS),
            y: isMobile ? 66.6 : threejsToCSS_Y(leftYThreeJS),
            width: threejsToCSS_Size(cardSizeThreeJS),
            scale: starScaleThreeJS // Usar la misma escala exacta
        },
        right: {
            x: threejsToCSS_X(rightXThreeJS),
            y: isMobile ? 67 : threejsToCSS_Y(leftYThreeJS),
            width: threejsToCSS_Size(cardSizeThreeJS),
            scale: starScaleThreeJS // Usar la misma escala exacta
        }
    };


    let cardsStagger = 1;

    phaseStarsTimeline

        // CARTAS IZQUIERDA
        .fromTo(leftCards,
            {
                opacity: 0,
            },
            {
                opacity: 1,
                duration: 0.05,
            }, 0.3)

        // CARTAS DERECHA
        .fromTo(rightCards,
            {
                opacity: 0,
            },
            {
                opacity: 1,
                duration: 0.05,
            }, 0.3)

        // ANIMACIÓN FINAL
        .to(leftCards,
            {
                left: isMobile ? "-100%" : "-30%",
                duration: 0.3,
                stagger: cardsStagger
            }, 1.02)
        .to(rightCards,
            {
                left: isMobile ? "200%" : "130%",
                duration: 0.3,
                stagger: cardsStagger
            }, 1.502);

    // Crear animaciones individuales para cada carta izquierda
    leftCards.forEach((card, index) => {
        phaseStarsTimeline.fromTo(card,
            {
                scale: minCardScale,
                top: cardData.left.y + "%",
                left: cardData.left.x + "%",
                width: cardData.left.width + "vw",
                x: "-50%",
                y: "-50%"
            },
            {
                scale: cardData.left.scale,
                duration: 0.5,
                x: isMobile ? "50%" : "-75%",
                y: isMobile ? "-85%" : "-65%",
                onStart: function() {
                    card.classList.add('moving');
                },
                onReverseComplete: function() {
                    card.classList.remove('moving');
                }
            }, 0.5 + (index * cardsStagger)
        );
    });

    // Crear animaciones individuales para cada carta derecha
    rightCards.forEach((card, index) => {
        phaseStarsTimeline.fromTo(card,
            {
                scale: minCardScale,
                top: cardData.right.y + "%",
                left: cardData.right.x + "%",
                width: cardData.right.width + "vw",
                x: "-50%",
                y: "-50%"
            },
            {
                scale: cardData.right.scale,
                x: isMobile ? "-125%" : "-25%",
                y: isMobile ? "-85%" : "-65%",
                duration: 0.5,
                onStart: function() {
                    card.classList.add('moving');
                },
                onReverseComplete: function() {
                    card.classList.remove('moving');
                }
            }, 1 + (index * cardsStagger)
        );
    });
}


function initResponsiveStarCards() {
    const starCards = document.querySelectorAll('.star-card');

    // Calcular tamaños base
    const baseCardWidth = visibleWidth / 5;
    const responsiveWidth = (baseCardWidth / visibleWidth) * 100;

    starCards.forEach(card => {
        // Establecer tamaño inicial responsivo
        card.style.width = Math.max(8, Math.min(20, responsiveWidth)) + 'vw';
        card.style.height = 'auto'; // Mantener aspect ratio

        // Opcional: Ajustar la altura si necesitas control específico
        const aspectRatio = 1.454545; // height/width ratio de las cartas
        card.style.maxHeight = (responsiveWidth * aspectRatio) + 'vw';
    });
}


function debugStarsCurtain() {

    if (starsMainGroup) {
        let visibleElements = 0;
        let totalElements = 0;

        starsMainGroup.traverse((child) => {
            if (child.isMesh) {
                totalElements++;
                if (child.material && child.material.uniforms) {
                    const alpha = child.material.uniforms.uOpacity?.value || 0;
                    if (alpha > 0.1) visibleElements++;
                }
            }
        });

    }
}

let phaseLegendsTimeline = undefined;
function initLegendsScrollTrigger() {
    // Inicializar el video con revelado progresivo
    initLegendsVideo();

    // Actualizar el overlay
    updateOverlayClipPath();

    phaseLegendsTimeline = gsap.timeline({
        scrollTrigger: {
            trigger: ".legends-wrapper",
            start: "top top",
            end: "bottom bottom",
            scrub: 1.5,
            onEnter: (self) => {
                document.body.classList.add('legends-ready');
                setTimeout(() => {
                    if (!isMobileDevice()) {
                        toggleCommonCardEffects(true);
                    }
                }, 1500);
            },
            onLeave: () => {
            },
            onEnterBack: () => {
                document.body.classList.add('legends-ready');
                setTimeout(() => {
                    toggleCommonCardEffects(true);
                }, 500);
            },
            onLeaveBack: () => {
                document.body.classList.remove('legends-ready');
                toggleCommonCardEffects(false);
            },
        }
    });

    let legendAspect = 1920/1342;
    const viewportHeight = window.innerHeight;
    const pixels = 40;
    const vhValue = (pixels / viewportHeight) * 100;
    let legendWidthFactor = isMobileDevice() ? 50 : 70;

    if (isMobileDevice()) {
        phaseLegendsTimeline
            .to('.legends-gallery .legend-card:nth-child(1)',
                {
                    top: '-35vh',
                    left: '-82vw',
                    scale: 0.8,
                    duration: 0.3,
                    ease: 'power4.out'
                }, '<')
            .to('.legends-gallery .legend-card:nth-child(2)',
                {
                    top: '-30vh',
                    left: '-13vw',
                    scale: 0.8,
                    duration: 0.3,
                    ease: 'power4.out'
                }, '<')
            .to('.legends-gallery .legend-card:nth-child(3)',
                {
                    top: '48vh',
                    left: '-125vw',
                    scale: 0.8,
                    duration: 0.3,
                    ease: 'power4.out'
                }, '<')
            .to('.legends-gallery .legend-card:nth-child(4)',
                {
                    top: '42vh',
                    left: '-18vw',
                    scale: 0.8,
                    duration: 0.3,
                    ease: 'power4.out'
                }, '<')

            .to('.legends-gallery',
                {
                    x: isMobileDevice() ? '-97%' : '-92%',
                    duration: 3,
                    ease: 'none'
                }, 0.65)
            .to('.legends-gallery .legend-card:nth-child(1)',
                {
                    top: isMobileDevice() ? '50%' : '0',
                    y: isMobileDevice() ? '-50%' : 'unset',
                    left: '0',
                    scale: 1,
                    duration: 0.3,
                    rotate: 0,
                    ease: 'power4.inOut'
                }, 0.55)
            .to('.legends-gallery .legend-card:nth-child(2)',
                {
                    top: isMobileDevice() ? '50%' : '0',
                    y: isMobileDevice() ? '-50%' : 'unset',
                    left: (legendAspect*legendWidthFactor+vhValue) + 'vh',
                    scale: 1,
                    duration: 0.3,
                    rotate: 0,
                    ease: 'power4.inOut'
                }, '<')
            .to('.legends-gallery .legend-card:nth-child(3)',
                {
                    top: isMobileDevice() ? '50%' : '0',
                    y: isMobileDevice() ? '-50%' : 'unset',
                    left: (legendAspect*legendWidthFactor+vhValue)*2 + 'vh',
                    scale: 1,
                    duration: 0.5,
                    rotate: 0,
                    ease: 'power4.inOut'
                }, '<')
            .to('.legends-gallery .legend-card:nth-child(4)',
                {
                    top: isMobileDevice() ? '50%' : '0',
                    y: isMobileDevice() ? '-50%' : 'unset',
                    left: (legendAspect*legendWidthFactor+vhValue)*3 + 'vh',
                    scale: 1,
                    duration: 0.5,
                    rotate: 0,
                    ease: 'power4.inOut'
                }, '<')

            .to('.legends-gallery .legend-card:nth-child(5)',
                {
                    marginLeft: (legendAspect*legendWidthFactor+vhValue)*4 + 'vh',
                    duration: 0.5,
                    rotate: 0,
                    ease: 'power4.inOut'
                }, '<')
            .to('.legends-title-wrapper',
                {
                    opacity: 0,
                    duration: 0.1,
                }, 0.8);
    } else {
        phaseLegendsTimeline
            .fromTo('.legends-title-wrapper',
                {
                    left: '50vw',
                },
                {
                    left: '4vw',
                    x: "50%",
                    duration: 0.1,
                }, 0)
            .to('.legends-gallery .legend-card:nth-child(1)',
                {
                    top: '-24vh',
                    left: '-13vw',
                    scale: 0.8,
                    duration: 0.3,
                    ease: 'power4.out'
                }, '<')
            .to('.legends-gallery .legend-card:nth-child(2)',
                {
                    top: '-21vh',
                    left: '20vw',
                    scale: 0.8,
                    duration: 0.3,
                    ease: 'power4.out'
                }, '<')
            .to('.legends-gallery .legend-card:nth-child(3)',
                {
                    top: '32vh',
                    left: '-9vw',
                    scale: 0.8,
                    duration: 0.3,
                    ease: 'power4.out'
                }, '<')
            .to('.legends-gallery .legend-card:nth-child(4)',
                {
                    top: '28vh',
                    left: '20vw',
                    scale: 0.8,
                    duration: 0.3,
                    ease: 'power4.out'
                }, '<')

            .to('.legends-gallery',
                {
                    x: isMobileDevice() ? '-97%' : '-92%',
                    duration: 3,
                    ease: 'none'
                }, 0.55)
            .to('.legends-gallery .legend-card:nth-child(1)',
                {
                    top: isMobileDevice() ? '50%' : '0',
                    y: isMobileDevice() ? '-50%' : 'unset',
                    left: '0',
                    scale: 1,
                    duration: 0.3,
                    rotate: 0,
                    ease: 'power4.inOut'
                }, '<')
            .to('.legends-gallery .legend-card:nth-child(2)',
                {
                    top: isMobileDevice() ? '50%' : '0',
                    y: isMobileDevice() ? '-50%' : 'unset',
                    left: (legendAspect*legendWidthFactor+vhValue) + 'vh',
                    scale: 1,
                    duration: 0.3,
                    rotate: 0,
                    ease: 'power4.inOut'
                }, '<')
            .to('.legends-gallery .legend-card:nth-child(3)',
                {
                    top: isMobileDevice() ? '50%' : '0',
                    y: isMobileDevice() ? '-50%' : 'unset',
                    left: (legendAspect*legendWidthFactor+vhValue)*2 + 'vh',
                    scale: 1,
                    duration: 0.5,
                    rotate: 0,
                    ease: 'power4.inOut'
                }, '<')
            .to('.legends-gallery .legend-card:nth-child(4)',
                {
                    top: isMobileDevice() ? '50%' : '0',
                    y: isMobileDevice() ? '-50%' : 'unset',
                    left: (legendAspect*legendWidthFactor+vhValue)*3 + 'vh',
                    scale: 1,
                    duration: 0.5,
                    rotate: 0,
                    ease: 'power4.inOut'
                }, '<')

            .to('.legends-gallery .legend-card:nth-child(5)',
                {
                    marginLeft: (legendAspect*legendWidthFactor+vhValue)*4 + 'vh',
                    duration: 0.5,
                    rotate: 0,
                    ease: 'power4.inOut'
                }, '<')
            .to('.legends-title-wrapper',
                {
                    opacity: 0,
                    duration: 0.1,
                }, 0.8);
    }


}
// AGREGAR AL FINAL DE script.js - Efecto Common sencillo para legends

// Función para inicializar el efecto Common sencillo
// REEMPLAZAR la función initCommonCardEffects() en script.js
// REEMPLAZAR la función initCommonCardEffects() en script.js
// Función para inicializar el efecto Common sencillo (VERSIÓN CORREGIDA)
function initCommonCardEffects() {
    const legendCards = document.querySelectorAll('.legends-wrapper .legend-card');

    legendCards.forEach(card => {
        // Almacenar el estado de cada carta en el propio elemento
        card._cardState = {
            leaveTimeout: null,
            isHovering: false,
            resetTimeline: null
        };

        card.addEventListener('mouseenter', function() {
            const state = card._cardState;
            state.isHovering = true;

            // Cancelar cualquier animación de reset en progreso
            if (state.resetTimeline) {
                state.resetTimeline.kill();
                state.resetTimeline = null;
            }

            // Cancelar cualquier timeout de salida pendiente
            if (state.leaveTimeout) {
                clearTimeout(state.leaveTimeout);
                state.leaveTimeout = null;
            }

            // Activar efectos hover y restaurar la opacidad del hover
            card.classList.add('card-hovering');
            gsap.set(card, { '--hover-opacity': 1 });
        });

        card.addEventListener('mousemove', function(e) {
            const rect = card.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;

            const centerX = rect.width / 2;
            const centerY = rect.height / 2;

            // Rotación 3D muy sutil (máximo 8 grados)
            const rotateX = (y - centerY) / centerY * 8;
            const rotateY = (centerX - x) / centerX * 8;

            // Posición del efecto de brillo
            const xPercent = (x / rect.width) * 100;
            const yPercent = (y / rect.height) * 100;

            // Aplicar transformación 3D sutil
            gsap.set(card, {
                transform: `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale3d(1.02, 1.02, 1.02)`,
                '--mouse-x': `${xPercent}%`,
                '--mouse-y': `${yPercent}%`
            });
        });

        card.addEventListener('mouseleave', function() {
            const state = card._cardState;
            state.isHovering = false;

            // Esperar 1 segundo antes de resetear
            state.leaveTimeout = setTimeout(() => {
                // Solo resetear si realmente no está hovering
                if (!state.isHovering) {
                    // Crear un timeline único para coordinar todas las animaciones
                    state.resetTimeline = gsap.timeline({
                        onComplete: () => {
                            // Remover la clase DESPUÉS de que termine la animación
                            card.classList.remove('card-hovering');
                            state.resetTimeline = null;
                        }
                    });

                    state.resetTimeline
                        // Animar transformación 3D
                        .to(card, {
                            transform: 'perspective(1000px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)',
                            duration: 0.8,
                            ease: "power2.out"
                        }, 0)
                        // Animar variables CSS al mismo tiempo
                        .to(card, {
                            '--mouse-x': '50%',
                            '--mouse-y': '50%',
                            '--hover-opacity': 0,
                            duration: 0.8,
                            ease: "power2.out"
                        }, 0);
                }
            }, 500); // 1 segundo de delay
        });

        // Efecto sutil al hacer click
        card.addEventListener('click', function() {
            const state = card._cardState;

            // Cancelar timeout de reset si existe
            if (state.leaveTimeout) {
                clearTimeout(state.leaveTimeout);
                state.leaveTimeout = null;
            }

            // Flash muy sutil
            gsap.fromTo(card,
                { filter: 'brightness(1.05) contrast(1.05) saturate(1.1)' },
                {
                    filter: 'brightness(1.15) contrast(1.15) saturate(1.2)',
                    duration: 0.1,
                    ease: "power2.out",
                    yoyo: true,
                    repeat: 1
                }
            );
        });
    });
}

// Función para activar/desactivar efectos
function toggleCommonCardEffects(active) {
    const legendCards = document.querySelectorAll('.legends-wrapper .legend-card');

    legendCards.forEach(card => {
        if (active) {
            card.style.pointerEvents = 'auto';
        } else {
            card.style.pointerEvents = 'none';

            // Limpiar cualquier timeout pendiente
            if (card.leaveTimeout) {
                clearTimeout(card.leaveTimeout);
                card.leaveTimeout = null;
            }

            // Resetear transformaciones inmediatamente
            gsap.set(card, {
                transform: 'perspective(1000px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)',
                '--mouse-x': '50%',
                '--mouse-y': '50%'
            });
        }
    });
}

// Detectar dispositivos móviles
function isMobileDevice() {
    return window.innerWidth <= 768;
}

function isIOSDevice() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

// Inicializar efectos cuando se carga la página
document.addEventListener('DOMContentLoaded', function() {
    if (!isMobileDevice()) {
        setTimeout(() => {
            initCommonCardEffects();
        }, 1000);
    }
});

// Limpiar efectos al cambiar de página
window.addEventListener('beforeunload', function() {
    toggleCommonCardEffects(false);
});

// Manejar redimensionamiento
window.addEventListener('resize', function() {
    /*
    const activeCards = document.querySelectorAll('.legends-wrapper .legend-card');
    activeCards.forEach(card => {
        gsap.set(card, {
            transform: 'perspective(1000px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)'
        });
    });

    const activeStarCards = document.querySelectorAll('.star-card .star-card-inner');
    activeStarCards.forEach(card => {
        gsap.set(card, {
            transform: 'perspective(1000px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)'
        });
    });

     */
});

// Función para inicializar el efecto hover de las star cards
function initStarCardEffects() {
    const starCards = document.querySelectorAll('.star-card .star-card-inner');

    starCards.forEach(card => {
        // Almacenar el estado de cada carta en el propio elemento
        card._cardState = {
            leaveTimeout: null,
            isHovering: false,
            resetTimeline: null
        };

        if (!isMobileDevice()) {
            card.addEventListener('mouseenter', function() {
                const state = card._cardState;
                state.isHovering = true;

                // Cancelar cualquier animación de reset en progreso
                if (state.resetTimeline) {
                    state.resetTimeline.kill();
                    state.resetTimeline = null;
                }

                // Cancelar cualquier timeout de salida pendiente
                if (state.leaveTimeout) {
                    clearTimeout(state.leaveTimeout);
                    state.leaveTimeout = null;
                }

                // Activar efectos hover y restaurar la opacidad del hover
                const starCard = card.closest('.star-card');
                const isFlipped = starCard.classList.contains('flipped');
                if (!isFlipped) {
                    card.classList.add('card-hovering');
                    gsap.set(card, { '--hover-opacity': 1 });
                }
            });

            card.addEventListener('mousemove', function(e) {
                const starCard = card.closest('.star-card');
                const isFlipped = starCard.classList.contains('flipped');
                if (!isFlipped) {
                    const rect = card.getBoundingClientRect();
                    const x = e.clientX - rect.left;
                    const y = e.clientY - rect.top;

                    const centerX = rect.width / 2;
                    const centerY = rect.height / 2;

                    // Rotación 3D muy sutil (máximo 8 grados)
                    const rotateX = (y - centerY) / centerY * 8;
                    const rotateY = (centerX - x) / centerX * 8;

                    // Posición del efecto de brillo
                    const xPercent = (x / rect.width) * 100;
                    const yPercent = (y / rect.height) * 100;

                    // Aplicar transformación 3D sutil
                    gsap.set(card, {
                        transform: `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale3d(1.02, 1.02, 1.02)`,
                        '--mouse-x': `${xPercent}%`,
                        '--mouse-y': `${yPercent}%`
                    });
                } else {
                }
            });

            card.addEventListener('mouseleave', function() {
                const state = card._cardState;
                state.isHovering = false;

                // Esperar 500ms antes de resetear
                state.leaveTimeout = setTimeout(() => {
                    // Solo resetear si realmente no está hovering
                    if (!state.isHovering) {
                        // Crear un timeline único para coordinar todas las animaciones
                        state.resetTimeline = gsap.timeline({
                            onComplete: () => {
                                // Remover la clase DESPUÉS de que termine la animación
                                card.classList.remove('card-hovering');
                                state.resetTimeline = null;
                            }
                        });

                        state.resetTimeline
                            // Animar transformación 3D
                            .to(card, {
                                transform: 'perspective(1000px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)',
                                duration: 0.8,
                                ease: "power2.out"
                            }, 0)
                            // Animar variables CSS al mismo tiempo
                            .to(card, {
                                '--mouse-x': '50%',
                                '--mouse-y': '50%',
                                '--hover-opacity': 0,
                                duration: 0.8,
                                ease: "power2.out"
                            }, 0);
                    }
                }, 500); // 500ms de delay
            });


        }
        // Dentro de initStarCardEffects(), reemplaza el event listener de click:
        card.addEventListener('click', function() {
            const state = card._cardState;

            // Cancelar timeout de reset si existe
            if (state.leaveTimeout) {
                clearTimeout(state.leaveTimeout);
                state.leaveTimeout = null;
            }

            const content = card.querySelector('.star-card-content');
            const starCard = card.closest('.star-card');

            if (content) {
                const isFlipped = content.classList.contains('flipped');
                const isShowingVideo = starCard.classList.contains('showing-video');

                if (!isFlipped && !isShowingVideo) {
                    // Voltear la carta y mostrar video
                    content.classList.add('flipped');
                    starCard.classList.add('flipped');

                    // Mostrar video si hay datos de video
                    if (starCard && starCardVideoSystem && starCard.dataset.videoId) {
                        starCardVideoSystem.showVideo(starCard);
                    }
                } else {
                    // Si ya está volteada o mostrando video, cerrar
                    starCardVideoSystem.closeVideo(starCard);
                }
            }

            // Flash efecto (mantener como estaba)
            gsap.fromTo(card,
                { filter: 'brightness(1.05) contrast(1.05) saturate(1.1)' },
                {
                    filter: 'brightness(1.15) contrast(1.15) saturate(1.2)',
                    duration: 0.1,
                    ease: "power2.out",
                    yoyo: true,
                    repeat: 1
                }
            );

        });
    });
}

// Función para activar/desactivar efectos de star cards
function toggleStarCardEffects(active) {
    const starCards = document.querySelectorAll('.star-card .star-card-inner');

    starCards.forEach(card => {
        if (active) {
            card.style.pointerEvents = 'auto';
        } else {
            card.style.pointerEvents = 'none';

            // Limpiar cualquier timeout pendiente
            if (card._cardState && card._cardState.leaveTimeout) {
                clearTimeout(card._cardState.leaveTimeout);
                card._cardState.leaveTimeout = null;
            }

            // Resetear transformaciones inmediatamente
            gsap.set(card, {
                transform: 'perspective(1000px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)',
                '--mouse-x': '50%',
                '--mouse-y': '50%',
                '--hover-opacity': 0
            });

            // Remover clase hover
            card.classList.remove('card-hovering');
        }
    });
}

// Versión simplificada - solo cambiar el método de bloqueo de scroll
class StarCardVideoSystem {
    constructor() {
        // Eliminar referencias a elementos globales de video
        this.currentCard = null;
        this.isVideoActive = false;
        this.scrollY = 0;

        this.init();
    }

    init() {
        // Escuchar clics en botones de cerrar dentro de las cartas
        document.addEventListener('click', (e) => {

            if (e.target.classList.contains('video-close-button-back')) {
                this.closeVideo(e.target.closest('.star-card'));
            }
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.isVideoActive) {
                this.closeAllVideos();
            }
        });
    }

    showVideo(card) {
        const videoId = isMobileDevice() ? card.dataset.mobileVideoId : card.dataset.videoId;
        const videoTitle = card.dataset.videoTitle || 'Highlights';
        const playerName = card.dataset.playerName || 'Player';

        if (!videoId) {
            console.warn('No video ID found for this card');
            return;
        }

        // Encontrar el contenedor de video dentro de la carta
        const videoContainer = card.querySelector('.video-container-back');
        const vimeoPlayer = card.querySelector('.vimeo-player-back');

        if (!videoContainer || !vimeoPlayer) {
            console.warn('Video container not found in card');
            return;
        }

        // Prevenir scroll
        this.scrollY = window.scrollY;
        document.addEventListener('scroll', this.preventScroll, { passive: false });
        document.addEventListener('touchmove', this.preventScroll, { passive: false });

        this.currentCard = card;
        this.isVideoActive = true;

        // Configurar el video
        const vimeoUrl = `https://player.vimeo.com/video/${videoId}?autoplay=1&loop=1&muted=1&background=1&portrait=0&title=0&byline=0`;
        vimeoPlayer.src = vimeoUrl;

        // Mostrar el video y ocultar la información de la carta
        setTimeout(() => {
            videoContainer.style.display = 'block';

            // Añadir clase para efectos CSS adicionales
            card.classList.add('showing-video');
        }, 50); // Esperar a que termine la animación de flip
    }

    preventScroll = (e) => {
        e.preventDefault();
        window.scrollTo(0, this.scrollY);
    }

    closeVideo(card) {
        const videoContainer = card.querySelector('.video-container-back');
        const vimeoPlayer = card.querySelector('.vimeo-player-back');

        if (videoContainer && vimeoPlayer) {
            // Ocultar video y mostrar información
            videoContainer.style.display = 'none';

            // Detener video
            vimeoPlayer.src = '';

            // Remover clase
            card.classList.remove('showing-video');
        }

        // Remover listeners de scroll solo si es la carta actual
        if (card === this.currentCard) {
            document.removeEventListener('scroll', this.preventScroll);
            document.removeEventListener('touchmove', this.preventScroll);
            this.isVideoActive = false;
            this.currentCard = null;
        }

        // Voltear la carta de vuelta
        const content = card.querySelector('.star-card-content');
        if (content) {
            content.classList.remove('flipped');
            card.classList.add('animate-flip-back');
            card.classList.remove('flipped');
            setTimeout(() => {
                card.classList.remove('animate-flip-back');
            }, 1000);
        }
    }

    closeAllVideos() {
        const flippedCards = document.querySelectorAll('.star-card.flipped');
        flippedCards.forEach(card => {
            this.closeVideo(card);
        });
    }
}
// Instancia global del sistema de video
let starCardVideoSystem = null;

// Alternativa más simple usando solo CSS transforms
function initMediaParallaxSimple() {
    gsap.timeline({
        scrollTrigger: {
            trigger: ".media-wrapper",
            start: "top bottom",
            end: "bottom top",
            scrub: 1.5
        }
    })
        .fromTo('.media-wrapper',
            {
                backgroundPosition: 'center 50%'
            },
            {
                backgroundPosition: 'center -50%',
                ease: "none"
            }
        );
}

// Inicializar cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', () => {
    starCardVideoSystem = new StarCardVideoSystem();
    initMediaParallaxSimple();
});

function initLegendsVideo() {
    const legendsVideo = document.querySelector('.legends-bg-video');
    const legendsWrapper = document.querySelector('.legends-wrapper');

    if (!legendsVideo || !legendsWrapper) return;

    // Configuración inicial
    legendsVideo.pause();

    // Función para actualizar el clip-path según la posición del scroll
    function updateVideoReveal() {
        const rect = legendsWrapper.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        // Calcular qué porcentaje de la sección legends está visible
        let revealPercentage = 0;

        if (rect.top <= 0 && rect.bottom >= windowHeight) {
            // La sección ocupa toda la pantalla o más
            revealPercentage = 100;
        } else if (rect.top < windowHeight && rect.bottom > 0) {
            // La sección está parcialmente visible
            if (rect.top >= 0) {
                // La sección está entrando desde abajo
                revealPercentage = Math.min(100, ((windowHeight - rect.top) / windowHeight) * 100);
            } else {
                // La sección está saliendo por arriba
                revealPercentage = 100;
                //revealPercentage = Math.min(100, (rect.bottom / windowHeight) * 100);
            }
        } else {
            // La sección no está visible
            revealPercentage = 0;
        }

        // Aplicar clip-path para revelar el video progresivamente
        const clipValue = Math.max(0, 100 - revealPercentage);
        const clipPath = `inset(${clipValue}% 0 0 0)`;

        legendsVideo.style.clipPath = clipPath;

        // También aplicar al overlay si existe
        const overlay = legendsWrapper.querySelector('::before');
        if (legendsWrapper.style.setProperty) {
            legendsWrapper.style.setProperty('--clip-path', clipPath);
        }

        // Actualizar el overlay usando una variable CSS o directamente
        document.documentElement.style.setProperty('--legends-clip-path', clipPath);

        // Controlar reproducción del video
        if (revealPercentage > 0) {
            legendsVideo.play().catch(e => {
                console.warn("Error reproduciendo video de legends:", e);
            });
        } else {
            legendsVideo.pause();
        }

        return revealPercentage;
    }

    // Usar requestAnimationFrame para scroll suave
    let ticking = false;

    function handleScroll() {
        if (!ticking) {
            requestAnimationFrame(() => {
                updateVideoReveal();
                ticking = false;
            });
            ticking = true;
        }
    }

    // Escuchar scroll
    window.addEventListener('scroll', handleScroll, { passive: true });

    // Intersection Observer como backup y para optimización
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Activar el control de scroll cuando legends es visible
                window.addEventListener('scroll', handleScroll, { passive: true });
            } else {
                // Pausar video y ocultar cuando no es visible
                legendsVideo.pause();
                legendsVideo.style.clipPath = 'inset(100% 0 0 0)';
                document.documentElement.style.setProperty('--legends-clip-path', 'inset(100% 0 0 0)');
            }
        });
    }, {
        threshold: 0,
        rootMargin: '50px'
    });

    observer.observe(legendsWrapper);

    // Manejar errores de carga del video
    legendsVideo.addEventListener('error', (e) => {
        console.warn('Error cargando video de legends:', e);
    });

    // Asegurar que el video se reinicie cuando termine
    legendsVideo.addEventListener('ended', () => {
        legendsVideo.currentTime = 0;
        // Solo reiniciar si está visible
        const rect = legendsWrapper.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
            legendsVideo.play().catch(e => console.warn("Error reiniciando video:", e));
        }
    });

    // Verificar posición inicial
    setTimeout(() => {
        updateVideoReveal();
    }, 500);

    // También verificar al cargar la página
    window.addEventListener('load', () => {
        setTimeout(updateVideoReveal, 1000);
    });
}

function updateOverlayClipPath() {
    const style = document.createElement('style');
    style.textContent = `
        .legends-wrapper::before {
            clip-path: var(--legends-clip-path, inset(100% 0 0 0)) !important;
        }
    `;
    document.head.appendChild(style);
}

$(document).ready(function(){
    $('.media-instagram').slick({
        centerMode: true,
        centerPadding: '60px',
        slidesToShow: 3,
        arrows: true,
        infinite: false,
        autoplay: false,
        autoplaySpeed: 4000,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });
    $('.media-instagram').slick('slickNext');
});

function createRoundedRectanglePath(x, y, width, height, radius) {
    const path = new THREE.Path();

    // Comenzar en la esquina superior izquierda (con radio)
    path.moveTo(x + radius, y + height);

    // Borde superior
    path.lineTo(x + width - radius, y + height);

    // Esquina superior derecha
    path.quadraticCurveTo(x + width, y + height, x + width, y + height - radius);

    // Borde derecho
    path.lineTo(x + width, y + radius);

    // Esquina inferior derecha
    path.quadraticCurveTo(x + width, y, x + width - radius, y);

    // Borde inferior
    path.lineTo(x + radius, y);

    // Esquina inferior izquierda
    path.quadraticCurveTo(x, y, x, y + radius);

    // Borde izquierdo
    path.lineTo(x, y + height - radius);

    // Esquina superior izquierda
    path.quadraticCurveTo(x, y + height, x + radius, y + height);

    return path;
}

if (isIOSDevice()) {
    // Listener para orientationchange
    window.addEventListener('orientationchange', () => {
        setTimeout(() => {
            if (starsRenderer && starsCamera) {
                starsCamera.aspect = sizes.width / sizes.height;
                starsCamera.updateProjectionMatrix();
                starsRenderer.setSize(sizes.width, sizes.height);
                forceStarsRender();
            }
        }, 500);
    });

    // Listener para visibilitychange
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible' && starsActive) {
            setTimeout(() => {
                forceStarsRender();
            }, 100);
        }
    });

    // Listener para pageshow (navegación back/forward)
    window.addEventListener('pageshow', (event) => {
        if (event.persisted && starsActive) {
            setTimeout(() => {
                forceStarsRender();
            }, 100);
        }
    });

    // Listener para focus/blur
    window.addEventListener('focus', () => {
        if (starsActive) {
            setTimeout(() => {
                forceStarsRender();
            }, 100);
        }
    });
}

function setupMenuNavigation() {
    const menuLinks = document.querySelectorAll('.menu-link[href^="#"]');

    menuLinks.forEach(link => {
        link.addEventListener('click', (e) => {
            const href = link.getAttribute('href');

            if (href === '#essence') {
                e.preventDefault();

                // Scroll hasta el punto donde el estadio está listo para hover
                const spacerElement = document.querySelector('.spacer');
                if (spacerElement) {
                    // Calcular la posición donde stadiumReady está activo
                    const spacerHeight = spacerElement.offsetHeight;
                    const targetProgress = 1.8 / phaseBTimeline.duration(); // stadiumReady está en 1.8
                    const targetScroll = spacerElement.offsetTop + (spacerHeight * targetProgress);

                    window.scrollTo({
                        top: targetScroll,
                        behavior: 'smooth'
                    });
                }
            }
        });
    });
}

class MenuVideoSystem {
    constructor() {
        this.videosLoaded = new Set();
        this.isMenuOpen = false;
        this.init();
    }

    init() {
        // Precargar videos cuando se abre el menú
        this.setupMenuToggleListener();
        // Configurar hover effects para videos
        this.setupVideoHoverEffects();
    }

    setupMenuToggleListener() {
        const menuButton = document.querySelector('.menu-button');
        const menuOverlay = document.getElementById('menu-overlay');

        if (menuButton && menuOverlay) {
            // Observer para detectar cuando el menú se abre
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.attributeName === 'class') {
                        const isOpen = menuOverlay.classList.contains('active');

                        if (isOpen && !this.isMenuOpen) {
                            this.isMenuOpen = true;
                            this.loadMenuVideos();
                        } else if (!isOpen && this.isMenuOpen) {
                            this.isMenuOpen = false;
                            this.pauseAllVideos();
                        }
                    }
                });
            });

            observer.observe(menuOverlay, { attributes: true });
        }
    }

    loadMenuVideos() {
        const videos = document.querySelectorAll('.menu-link video[data-src]');

        videos.forEach((video, index) => {
            const src = video.dataset.src;

            if (src && !this.videosLoaded.has(src)) {
                // Cargar con un pequeño delay para escalonar la carga
                setTimeout(() => {
                    this.loadVideo(video, src);
                }, index * 100);
            }
        });
    }

    loadVideo(video, src) {
        // Crear un elemento temporal para verificar que el video se puede cargar
        const tempVideo = document.createElement('video');

        tempVideo.onloadeddata = () => {
            // Video cargado exitosamente, ahora asignarlo al video real
            video.src = src;
            video.load();
            this.videosLoaded.add(src);

            // Configurar el video
            video.muted = true;
            video.loop = true;
            video.playsInline = true;

            // Remover el data-src ya que ya está cargado
            video.removeAttribute('data-src');

            // Añadir clase para indicar que está listo
            video.classList.add('video-loaded');

            console.log(`✅ Video cargado: ${src}`);
        };

        tempVideo.onerror = () => {
            console.warn(`⚠️ Error cargando video: ${src}`);
            // Marcar como "cargado" para evitar reintentos
            this.videosLoaded.add(src);
        };

        // Iniciar la carga
        tempVideo.src = src;
    }

    setupVideoHoverEffects() {
        const menuLinks = document.querySelectorAll('.menu-link');

        menuLinks.forEach(link => {
            const video = link.querySelector('video');

            if (video) {
                link.addEventListener('mouseenter', () => {
                    if (video.src && video.readyState >= 2) { // HAVE_CURRENT_DATA
                        video.play().catch(e => {
                            console.warn('No se pudo reproducir el video del menú:', e);
                        });
                    }
                });

                link.addEventListener('mouseleave', () => {
                    if (video.src) {
                        video.pause();
                        video.currentTime = 0; // Reiniciar al principio
                    }
                });
            }
        });
    }

    pauseAllVideos() {
        const videos = document.querySelectorAll('.menu-link video');
        videos.forEach(video => {
            if (video.src) {
                video.pause();
                video.currentTime = 0;
            }
        });
    }

    // Método público para limpiar recursos si es necesario
    destroy() {
        this.pauseAllVideos();
        this.videosLoaded.clear();
    }
}

document.addEventListener('DOMContentLoaded', function() {
        // Inicializar el sistema de videos del menú
        const menuVideoSystem = new MenuVideoSystem();

        // Hacer disponible globalmente para debugging
        window.menuVideoSystem = menuVideoSystem;

        // Limpiar al salir de la página
        window.addEventListener('beforeunload', () => {
            menuVideoSystem.destroy();
        });

});

document.addEventListener('wpcf7mailsent', function (event) {
    const formWrapper = document.querySelector('.contact-form-wrapper');
    if (formWrapper) {
        formWrapper.innerHTML = '<p class="success-message">¡Gracias! Tu mensaje ha sido enviado.</p>';
    }
});